<template>
  <div class="page" ref="mutualIndex" :style="[getBgInfo, getBoxShadowInfo]">
    <!-- 实习生写的代码，若要维护，建议重写。 -->
    <div
      class="page-container"
      v-if="dataInfo.info.pages && dataInfo.info.pages.length !== 0"
    >
      <el-container :style="{
        maxWidth: getMaxWidth,
      }">
        <!-- <el-aside style="background-color: initial; border-right: none;" v-if="isTowColumn" width="208px" /> -->
        <!-- 侧边导航栏 -->
        <el-aside
          width="180px"
          class="navbar-left"
          ref="leftMenu"
          :style="{
            border: !(dataInfo.info.navbarConfig.action !== 'hidden' && dataInfo.info.navbarConfig.position === 'left') ? 'none' : ''
          }"
          v-if="dataInfo.info.navbarConfig.action !== 'hidden' && dataInfo.info.navbarConfig.position === 'left'"
        >
          <div class="side-btn" @click="closeMenu('left')">
            <i
              class="iconfont icon-shuangjiantouzuo"
              :class="{ 'menu-active': isShowMenu }"
            ></i>
          </div>
          <el-scrollbar style="height: 100%">
            <ul class="navbar">
              <li
                class="navbar-item-left"
                :class="{ active: dataInfo.pageId === item.value }"
                @click="switchPage(item)"
                :style="{
                  background:
                    dataInfo.pageId === item.value
                      ? colorRgb(themeColor, 0.1)
                      : '',
                }"
                v-for="item in dataInfo.info.pages"
                :key="item.value"
              >
                <div class="navbar-item-left-container">
                  <i :class="`iconfont ${handleNavBarIcon(item.icon)}`"></i>
                  <span>{{ item.label }}</span>
                </div>
                <div class="red-title" v-if="typePageNum(item.value)">
                  {{ typePageNum(item.value) }}
                </div>
              </li>
            </ul>
          </el-scrollbar>
        </el-aside>
        <template v-if="((dataInfo.info.clickEffect && dataInfo.info.clickEffect.toolNav === 'open') || dataInfo.info.clickEffect === undefined) && leftListLayout.length !== 0 && Object.keys(powerData[1]).length !== 0 && Object.keys(powerData[0]).length !== 0 && dataInfo.pageId !== '10'">
          <div v-for="(item, index) in leftListLayout" :key="index" class="tools-left" :style="[{ width: (item.customW || 180) + 'px' }, getToolBgInfo(item)]">
            <div class="drag-area" ref="leftDragArea">
              <div class="change-btn" v-if="item.changeBtn">
                <screenBtn :themeColor="themeColor" :isLeft="true" :changeBtn="item.changeBtn" @change-active="changeActiveId($event, item)" :activeId="item.activeId"/>
              </div>
              <div v-if="item.type === 'tool'" class="tools-container">
                <!-- 这边需要给一个高度 不然它不会自动撑开 -->
                <div class="drag-left-content" :style="{ flex: isAdaption(leftLayout(item)) ? '1' : '', height: isAdaption(leftLayout(item)) ? '0px' : '' }">
                  <div
                    :key="comps.i"
                    v-for="comps in leftLayout(item)"
                    style="width: 100%;"
                    :style="{ flex: comps.isAdaption ? '1' : '', height: comps.isAdaption ? '' : getScreenRectInfo(comps, 'customH'), padding: comps.type === 'screen' ? '' : '0 10px', overflowY: 'auto', flexShrink: 0 }"
                  >
                    <button-comp
                      v-if="comps.type === 'button' || comps.type === 'button-container'"
                      ref="buttonRef"
                      :fontStyle="item.fontStyle"
                      :info="comps"
                      :applyInfo="dataInfo.info.apply"
                      :themeColor="themeColor"
                      :listInfo="dataInfo.info[dataInfo.pageId].pageList"
                      :currentOrg="currentOrg"
                      :orgList="orgList"
                      :currentUser="currentUser"
                      :writePower="pagePower.writeTable"
                      :tableListInfo="listInfo"
                      :searchCriteria="searchCriteria"
                      :multipleSelection="multipleSelection"
                      :pageId="dataInfo.pageId"
                      :powerData="powerData"
                      :pagePower="pagePower"
                      :organizationalParameters="organizationalParameters"
                      :querys="querys"
                      :ruledata="ruledata"
                      :screenRef="$refs.screenRef"
                      :customData="customParams"
                      :isLeft="true"
                      :screenFixQuery="screenFixQuery"
                      :tableConfig="dataInfo.info"
                      @appPrint="appPrint"
                      @openDataSync="openDataSync"
                      @updateTable="handleButton"
                      @to-nav="$emit('to-nav', $event)"
                      @open-appDialog="openAppDialog"
                      @edit-user-info="editUserInfo"
                      @uploadBlock="blockchainChange = $event"
                      @openAppInitiate="openAppInitiate"
                      @custom-scene="customScene"
                      @tableDetail="tableDetail"
                      @progress-show="isProgressView = $event"
                      @progress-status="progressStatus"
                      @open-dictionary="openDictionary"
                      @change-check-field="changeCheckField"
                      @field-show="fieldShow"
                      @exportPivot="exportPivot"
                    ></button-comp>
                    <search-comp
                      v-else-if="comps.type === 'search'"
                      :fontStyle="item.fontStyle"
                      :themeColor="themeColor"
                      :applyInfo="dataInfo.info.apply"
                      @search-todo="handleSearch"
                      :info="comps"
                    ></search-comp>
                    <screen-comp
                      v-else-if="comps.type === 'screen'"
                      :fontStyle="item.fontStyle"
                      :themeColor="themeColor"
                      :isInit="dataInfo.info.tableStyleField ? dataInfo.info.tableStyleField.isInitTable : true"
                      :isLeft="true"
                      :applyInfo="dataInfo.info.apply"
                      :powerData="powerData"
                      :totalParams="totalParams"
                      :pageId="dataInfo.pageId"
                      :noChangeScreenId="noChangeScreenId"
                      :addConfig="addConfig"
                      :screenRef="$refs.screenRef"
                      :customData="customParams"
                      :customDeskId="customDeskId"
                      :isAppDesign="isAppDesign"
                      :key="comps.i"
                      :isSotpInitTable="stopInitScreenList.includes(comps.i)"
                      @open-dictionary="openDictionary"
                      @openAppInitiate="openAppInitiate"
                      @to-nav="$emit('to-nav', $event)"
                      @custom-scene="customScene"
                      @open-appDialog="openAppDialog"
                      @todo-inside="todoInside"
                      @change="handelChangeVal"
                      @change-screen-id="noChangeScreenId = $event"
                      @change-new-rel-radio="changeNewRelRadio"
                      @change-value="screenChange"
                      @change-new-screen="screenNewChange"
                      ref="screenRef"
                      :dataInfo="comps"
                    ></screen-comp>
                  </div>
                </div>
                <div class="drag-right-content" :style="{ flex: isAdaption(rightLayout(item)) ? '1' : '', height: isAdaption(rightLayout(item)) ? '0px' : ''  }">
                  <div
                    :key="comps.i"
                    v-for="comps in rightLayout(item)"
                    style="width: 100%;"
                    :style="{ flex: comps.isAdaption ? '1' : '', height: comps.isAdaption ? '' : getScreenRectInfo(comps, 'customH'), padding: comps.type === 'screen' ? '' : '0 10px' }"
                  >
                    <button-comp
                      v-if="comps.type === 'button' || comps.type === 'button-container'"
                      ref="buttonRef"
                      :fontStyle="item.fontStyle"
                      :info="comps"
                      :applyInfo="dataInfo.info.apply"
                      :themeColor="themeColor"
                      :listInfo="dataInfo.info[dataInfo.pageId].pageList"
                      :currentOrg="currentOrg"
                      :orgList="orgList"
                      :currentUser="currentUser"
                      :writePower="pagePower.writeTable"
                      :tableListInfo="listInfo"
                      :searchCriteria="searchCriteria"
                      :multipleSelection="multipleSelection"
                      :pageId="dataInfo.pageId"
                      :powerData="powerData"
                      :pagePower="pagePower"
                      :organizationalParameters="organizationalParameters"
                      :querys="querys"
                      :ruledata="ruledata"
                      :screenRef="$refs.screenRef"
                      :customData="customParams"
                      :isLeft="true"
                      :screenFixQuery="screenFixQuery"
                      :tableConfig="dataInfo.info"
                      @appPrint="appPrint"
                      @updateTable="handleButton"
                      @to-nav="$emit('to-nav', $event)"
                      @openDataSync="openDataSync"
                      @open-appDialog="openAppDialog"
                      @edit-user-info="editUserInfo"
                      @uploadBlock="blockchainChange = $event"
                      @openAppInitiate="openAppInitiate"
                      @custom-scene="customScene"
                      @tableDetail="tableDetail"
                      @open-dictionary="openDictionary"
                      @change-check-field="changeCheckField"
                      @field-show="fieldShow"
                      @exportPivot="exportPivot"
                    ></button-comp>
                    <search-comp
                      v-else-if="comps.type === 'search'"
                      :fontStyle="item.fontStyle"
                      :themeColor="themeColor"
                      :applyInfo="dataInfo.info.apply"
                      @search-todo="handleSearch"
                      :info="comps"
                    ></search-comp>
                    <screen-comp
                      v-else-if="comps.type === 'screen'"
                      :fontStyle="item.fontStyle"
                      :themeColor="themeColor"
                      :isInit="dataInfo.info.tableStyleField ? dataInfo.info.tableStyleField.isInitTable : true"
                      :isLeft="true"
                      :applyInfo="dataInfo.info.apply"
                      :powerData="powerData"
                      :totalParams="totalParams"
                      :pageId="dataInfo.pageId"
                      :noChangeScreenId="noChangeScreenId"
                      :addConfig="addConfig"
                      :screenRef="$refs.screenRef"
                      :customData="customParams"
                      :customDeskId="customDeskId"
                      :isAppDesign="isAppDesign"
                      :isSotpInitTable="stopInitScreenList.includes(comps.i)"
                      @open-dictionary="openDictionary"
                      @openAppInitiate="openAppInitiate"
                      @to-nav="$emit('to-nav', $event)"
                      @custom-scene="customScene"
                      @open-appDialog="openAppDialog"
                      @todo-inside="todoInside"
                      @change-screen-id="noChangeScreenId = $event"
                      @change="handelChangeVal"
                      @change-new-rel-radio="changeNewRelRadio"
                      @change-value="screenChange"
                      @change-new-screen="screenNewChange"
                      ref="screenRef"
                      :dataInfo="comps"
                    ></screen-comp>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <organizationList :isGetData="dealScreenOpt(getScreen)" :isDoor="true" v-if="isOpenOrg" :config="dataInfo.info.organizationalStructure" :organizationType="organizationType" @treeToSearch="treeToSearch" @setOrgList="setOrgList" />
        <el-container direction="vertical">
          <!-- 顶部导航栏 -->
          <el-header
            class="navbar-top"
            height="41px"
            ref="topMenu"
            v-if="
              dataInfo.info.navbarConfig.action !== 'hidden' &&
              dataInfo.info.navbarConfig.position === 'top'
            "
          >
            <div class="side-btn" @click="closeMenu('top')">
              <i
                class="iconfont icon-shuangjiantouzuo"
                :class="{ 'menu-active': isShowMenu }"
              ></i>
            </div>
            <ul class="navbar">
              <li
                class="navbar-item-top"
                :class="{
                  active: dataInfo.pageId === item.value,
                  'read-item': '3' === item.value,
                }"
                @click="switchPage(item)"
                v-for="item in dataInfo.info.pages"
                :key="item.value"
              >
                <div
                  class="top-c"
                  :style="{
                    background:
                      dataInfo.pageId === item.value
                        ? colorRgb(themeColor, 0.1)
                        : '',
                  }"
                >
                  <span>{{ item.label }}</span>
                </div>
                <div class="red-title" v-if="typePageNum(item.value)">
                  {{ typePageNum(item.value) }}
                </div>
              </li>
            </ul>
          </el-header>
          <div class="vertical-container" v-show="isPower && validateType === 4">
            <template v-if="((dataInfo.info.clickEffect && dataInfo.info.clickEffect.toolNav === 'open') || dataInfo.info.clickEffect === undefined) && topListLayout.length !== 0 && Object.keys(powerData[1]).length !== 0 && Object.keys(powerData[0]).length !== 0 && dataInfo.pageId !== '10'">
            <!-- 顶部工具栏 -->
              <el-header
                style="height: initail; padding: 0;background-color: transparent;"
                class="mutual-header"
                height="auto"
                v-if="dataInfo.pageId !== '8' && dataInfo.pageId !== '9' && topListLayout.length !== 0"
              >
                <div class="header-tools">
                  <div>
                    <div class="header-tools-item" :style="[{ height: item.type === 'bigsearch' ? 'auto' :'40px' }, getToolBgInfo(item)]" v-for="item in topListLayout" :key="item.i">
                      <div class="drag-area" ref="dragArea">
                        <div class="tools-container">
                          <template v-if="item.type === 'tool'">
                            <div class="drag-left-content" :style="{ flex: isAdaption(leftLayout(item)) ? '1' : '' }">
                              <div
                                :key="comps.i"
                                v-for="comps in leftLayout(item)"
                                :style="{ width: getScreenRectInfo(comps, 'customW'), flex: comps.isAdaption ? '1' : '' }"
                              >
                                <button-comp
                                  v-if="comps.type === 'button' || comps.type === 'button-container'"
                                  ref="buttonRef"
                                  :fontStyle="item.fontStyle"
                                  :info="comps"
                                  :applyInfo="dataInfo.info.apply"
                                  :themeColor="themeColor"
                                  :listInfo="dataInfo.info[dataInfo.pageId].pageList"
                                  :currentOrg="currentOrg"
                                  :orgList="orgList"
                                  :currentUser="currentUser"
                                  :writePower="pagePower.writeTable"
                                  :tableListInfo="listInfo"
                                  :searchCriteria="searchCriteria"
                                  :multipleSelection="multipleSelection"
                                  :pageId="dataInfo.pageId"
                                  :powerData="powerData"
                                  :pagePower="pagePower"
                                  :organizationalParameters="organizationalParameters"
                                  :querys="querys"
                                  :ruledata="ruledata"
                                  :screenRef="$refs.screenRef"
                                  :customData="customParams"
                                  :screenFixQuery="screenFixQuery"
                                  :tableConfig="dataInfo.info"
                                  @appPrint="appPrint"
                                  @updateTable="handleButton"
                                  @openDataSync="openDataSync"
                                  @to-nav="$emit('to-nav', $event)"
                                  @open-appDialog="openAppDialog"
                                  @edit-user-info="editUserInfo"
                                  @uploadBlock="blockchainChange = $event"
                                  @openAppInitiate="openAppInitiate"
                                  @custom-scene="customScene"
                                  @tableDetail="tableDetail"
                                  @progress-show="isProgressView = $event"
                                  @progress-status="progressStatus"
                                  @open-dictionary="openDictionary"
                                  @change-check-field="changeCheckField"
                                  @field-show="fieldShow"
                                  @exportPivot="exportPivot"
                                ></button-comp>
                                <search-comp
                                  v-else-if="comps.type === 'search'"
                                  :fontStyle="item.fontStyle"
                                  :themeColor="themeColor"
                                  :applyInfo="dataInfo.info.apply"
                                  @search-todo="handleSearch"
                                  :info="comps"
                                ></search-comp>
                                <screen-comp
                                  v-else-if="comps.type === 'screen'"
                                  ref="screenRef"
                                  :fontStyle="item.fontStyle"
                                  :themeColor="themeColor"
                                  :isInit="dataInfo.info.tableStyleField ? dataInfo.info.tableStyleField.isInitTable : true"
                                  :applyInfo="dataInfo.info.apply"
                                  :powerData="powerData"
                                  :totalParams="totalParams"
                                  :pageId="dataInfo.pageId"
                                  :noChangeScreenId="noChangeScreenId"
                                  :addConfig="addConfig"
                                  :screenRef="$refs.screenRef"
                                  :customData="customParams"
                                  :customDeskId="customDeskId"
                                  :isAppDesign="isAppDesign"
                                  :isSotpInitTable="stopInitScreenList.includes(comps.i)"
                                  @open-dictionary="openDictionary"
                                  @openAppInitiate="openAppInitiate"
                                  @to-nav="$emit('to-nav', $event)"
                                  @custom-scene="customScene"
                                  @open-appDialog="openAppDialog"
                                  @todo-inside="todoInside"
                                  @change-screen-id="noChangeScreenId = $event"
                                  @change="handelChangeVal"
                                  @change-new-rel-radio="changeNewRelRadio"
                                  @change-value="screenChange"
                                  @change-new-screen="screenNewChange"
                                  :dataInfo="comps"
                                ></screen-comp>
                              </div>
                            </div>
                            <div class="drag-right-content" :style="{ flex: isAdaption(rightLayout(item)) ? '1' : '' }">
                              <div
                                :key="comps.i"
                                v-for="comps in rightLayout(item)"
                                :style="{ width: getScreenRectInfo(comps, 'customW') }"
                              >
                                  <!-- v-model:cardFilePosition="dataInfo.info.appListInfo.card.filePosition"
                                  v-model:listCheck="dataInfo.info.checkSyllable" -->
                                <button-comp
                                  v-if="comps.type === 'button' || comps.type === 'button-container'"
                                  ref="buttonRef"
                                  :fontStyle="item.fontStyle"
                                  :info="comps"
                                  :applyInfo="dataInfo.info.apply"
                                  :themeColor="themeColor"
                                  :listInfo="dataInfo.info[dataInfo.pageId].pageList"
                                  :currentOrg="currentOrg"
                                  :screenRef="$refs.screenRef"
                                  :orgList="orgList"
                                  :currentUser="currentUser"
                                  :writePower="pagePower.writeTable"
                                  :tableListInfo="listInfo"
                                  :searchCriteria="searchCriteria"
                                  :multipleSelection="multipleSelection"
                                  :pageId="dataInfo.pageId"
                                  :powerData="powerData"
                                  :pagePower="pagePower"
                                  :organizationalParameters="organizationalParameters"
                                  :querys="querys"
                                  :ruledata="ruledata"
                                  :customData="customParams"
                                  :screenFixQuery="screenFixQuery"
                                  :tableConfig="dataInfo.info"
                                  @appPrint="appPrint"
                                  @updateTable="handleButton"
                                  @openDataSync="openDataSync"
                                  @to-nav="$emit('to-nav', $event)"
                                  @open-appDialog="openAppDialog"
                                  @edit-user-info="editUserInfo"
                                  @uploadBlock="blockchainChange = $event"
                                  @openAppInitiate="openAppInitiate"
                                  @custom-scene="customScene"
                                  @tableDetail="tableDetail"
                                  @open-dictionary="openDictionary"
                                  @change-check-field="changeCheckField"
                                  @field-show="fieldShow"
                                  @exportPivot="exportPivot"
                                ></button-comp>
                                <search-comp
                                  v-else-if="comps.type === 'search'"
                                  :fontStyle="item.fontStyle"
                                  :themeColor="themeColor"
                                  :applyInfo="dataInfo.info.apply"
                                  @search-todo="handleSearch"
                                  :info="comps"
                                ></search-comp>
                                <screen-comp
                                  v-else-if="comps.type === 'screen'"
                                  :fontStyle="item.fontStyle"
                                  :themeColor="themeColor"
                                  :applyInfo="dataInfo.info.apply"
                                  :powerData="powerData"
                                  :totalParams="totalParams"
                                  :pageId="dataInfo.pageId"
                                  :noChangeScreenId="noChangeScreenId"
                                  ref="screenRef"
                                  :screenRef="$refs.screenRef"
                                  :isInit="dataInfo.info.tableStyleField ? dataInfo.info.tableStyleField.isInitTable : true"
                                  :addConfig="addConfig"
                                  :customData="customParams"
                                  :customDeskId="customDeskId"
                                  :isAppDesign="isAppDesign"
                                  :isSotpInitTable="stopInitScreenList.includes(comps.i)"
                                  @open-dictionary="openDictionary"
                                  @openAppInitiate="openAppInitiate"
                                  @to-nav="$emit('to-nav', $event)"
                                  @custom-scene="customScene"
                                  @open-appDialog="openAppDialog"
                                  @todo-inside="todoInside"
                                  @change="handelChangeVal"
                                  @change-new-rel-radio="changeNewRelRadio"
                                  @change-screen-id="noChangeScreenId = $event"
                                  @change-value="screenChange"
                                  @change-new-screen="screenNewChange"
                                  :dataInfo="comps"
                                ></screen-comp>
                              </div>
                            </div>
                          </template>
                          <template v-else-if="item.type === 'bigsearch'">
                            <bigSearch @search-todo="handleSearch" :info="item" :themeColor="themeColor" />
                          </template>
                        </div>
                        <div class="change-btn" v-if="item.changeBtn">
                          <screenBtn :themeColor="themeColor" :changeBtn="item.changeBtn" @change-active="changeActiveId($event, item)" :activeId="item.activeId" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-header>
            </template>
            <!-- 内容 -->
            <div class="split-container" style="overflow: auto;">
              <template v-if="splitScreenInfo && splitScreenInfo.isSplit">
                <splitPanel isDisabled :gapSize="(splitScreenInfo.config.splitInfo.listAppen === 'hidden' || splitScreenInfo.config.splitInfo.screenAppen === 'hidden') ? 0 : 10" :splitBg="getBgInfo" :splitInfo="splitInfoComp" :customData="customParams">
                  <template v-slot:[`${splitPanelSlot}Btn`] v-if="!(listInfo.tableData.length === 0 && dataInfo.info.tableStyleField && dataInfo.info.tableStyleField.isInitTable === false)">
                    <div v-if="(splitScreenInfo.config.splitInfo.listAppen !== 'hidden' && splitScreenInfo.config.splitInfo.screenAppen !== 'hidden')" class="split-todo" @click="closeSplitScreen('screenAppen')" :class="[getSplitTodoScreen('screen'), `${splitPanelSlot}Btn`]">
                      <el-tooltip effect="dark" :disabled="!splitScreenInfo.config.splitInfo.screenTips" :content="splitScreenInfo.config.splitInfo.screenTips" placement="top">
                        <i class="iconfont icon-xia"></i>
                      </el-tooltip>
                    </div>
                  </template>
                  <template v-slot:[`${oppSplitPanelSlot}Btn`] v-if="!(listInfo.tableData.length === 0 && dataInfo.info.tableStyleField && dataInfo.info.tableStyleField.isInitTable === false)">
                    <div v-if="(splitScreenInfo.config.splitInfo.listAppen !== 'hidden' && splitScreenInfo.config.splitInfo.screenAppen !== 'hidden')" class="split-todo" @click="closeSplitScreen('listAppen')" :class="[getSplitTodoScreen('list'), `${splitPanelSlot === 'paneS' ? 'paneF' : 'paneS'}Btn`]">
                      <el-tooltip effect="dark" :disabled="!splitScreenInfo.config.splitInfo.listTips" :content="splitScreenInfo.config.splitInfo.listTips" placement="top">
                        <i class="iconfont icon-xia"></i>
                      </el-tooltip>
                    </div>
                  </template>
                  <template v-slot:[splitPanelSlot]>
                    <div class="split-screen" v-if="isAppenScreen">
                      <splitScreen :tableStyleField="dataInfo.info.tableStyleField" :isGetListData="isGetListData" :initConfig="dataInfo.info.initConfig" @updateTable="handleButton" :detailInfo="detailInfo" ref="splitScreen" :customDeskId="customDeskId" :screenRef="$refs.screenRef" :currentOrg="currentOrg" :currentUser="currentUser" :appId="dataInfo.info.apply.id" :customData="customParams" :splitInfo="splitScreenInfo && splitScreenInfo.config" />
                    </div>
                  </template>
                  <template v-slot:[oppSplitPanelSlot]>
                    <el-main v-show="splitScreenInfo.config.splitInfo.listAppen !== 'hidden'" class="table-content" :style="[getTableBgInfo,{padding:`${ dataInfo.info[dataInfo.pageId].pageList.tableStyle === 'list' ? dataInfo.info.listStyleConfig && dataInfo.info.listStyleConfig.minMargin || 10 : (dataInfo.info.listStyleConfig && dataInfo.info.listStyleConfig.minMargin || 10) / 2 }px` }]" style="padding-bottom: 0;position: relative;overflow: hidden">
                      <!-- 列表标题 -->
                      <customTitle :info="dataInfo.info.listStyleConfig.titleStyle" v-if="dataInfo.info.tableStyleField.isAppenTitle"/>
                      <!-- 列表模式 -->
                      <template v-if="dataInfo.info.tableStyleField.loadingMethod === 'pageScroll'">
                        <div v-if="listInfo.currentPage > 1" class="page-change-left page-change" @click="scrollChange('prev')">
                          <i class="iconfont icon-shuangjiantouzuo"></i>
                        </div>
                        <div class="page-change-right page-change" v-if="isNextChange" @click="scrollChange('next')">
                          <i class="iconfont icon-shuangjiantouyou"></i>
                        </div>
                      </template>
                      <div style="flex: 1;position: relative; overflow: hidden;">
                        <template v-if="dataInfo.info[dataInfo.pageId].pageList.tableStyle === 'list'">
                        <template v-if="!['3', '8', '9', '10'].includes(dataInfo.pageId)">
                            <vxeTable
                              ref="oneChild"
                              :navIndex="0"
                              :isDoor="true"
                              :customDeskId="customDeskId"
                              :openAction="dataInfo.info[dataInfo.pageId].pageList.openAction"
                              :pageList="dataInfo.info[dataInfo.pageId].pageList"
                              :dataInfo="dataInfo.info"
                              v-model:listInfo="listInfo"
                              :approvalId="dataInfo.info.apply.id"
                              :jurisdiction="jurisdiction"
                              :checkSyllable="tableCheckField"
                              v-model:multipleParentSelection="multipleSelection"
                              :pageId="dataInfo.pageId"
                              :isGetListData="isGetListData"
                              :aitableHide="aitableHide"
                              :approvalInfo="approval"
                              :loading="loading"
                              :currentOrg="currentOrg"
                              :screenRef="$refs.screenRef"
                              @edit-user-info="editUserInfo"
                              @openDataSync="openDataSync"
                              @appPrint="appPrint"
                              @change-currpage="handleChangePageInfo"
                              @goSearch="goListSearch"
                              @open-appDialog="openAppDialog"
                              @sourceAudit="sourceAudit"
                              @resetRefresh="resetRefresh"
                              @smsVerifi="smsVerifiFun"
                              @toBottom="toBottom"
                              @click-table="clickTable"
                              @todo-inside="todoInside"
                              @todo-outside="todoInside"
                              @custom-scene="customScene"
                              @open-dictionary="openDictionary"
                              @to-nav="$emit('to-nav', $event)"
                              />
                              <!-- v-if="dataInfo.info.apply.id !== 38858"
                              />
                            <transactionManagementList
                              ref="oneChild"
                              :navIndex="0"
                              :isDoor="true"
                              :customDeskId="customDeskId"
                              :openAction="dataInfo.info[dataInfo.pageId].pageList.openAction"
                              :pageList="dataInfo.info[dataInfo.pageId].pageList"
                              :tableStyleField="dataInfo.info.tableStyleField"
                              v-model:listInfo="listInfo"
                              :approvalId="dataInfo.info.apply.id"
                              :jurisdiction="jurisdiction"
                              :checkSyllable="tableCheckField"
                              :listTodoField="listTodoField"
                              :pivotConfig="dataInfo.info.pivotConfig"
                              v-model:multipleSelection="multipleSelection"
                              :clickEffect="dataInfo.info.clickEffect"
                              :tableTodoList="dataInfo.info.clientTableTodoList"
                              :rightTodoList="dataInfo.info.rightTodoList"
                              :pageId="dataInfo.pageId"
                              :listStyleConfig="dataInfo.info.listStyleConfig"
                              :listTodoConfig="dataInfo.info.listTodoConfig"
                              :initConfig="dataInfo.info.initConfig"
                              :titleRowConfig="dataInfo.info.titleRowConfig"
                              :filedWidthList="dataInfo.info.filedWidthList"
                              :isGetListData="isGetListData"
                              :aitableHide="aitableHide"
                              :approvalInfo="approval"
                              @edit-user-info="editUserInfo"
                              @openDataSync="openDataSync"
                              @appPrint="appPrint"
                              @change-currpage="handleChangePageInfo"
                              @goSearch="goListSearch"
                              @open-appDialog="openAppDialog"
                              @sourceAudit="sourceAudit"
                              @resetRefresh="resetRefresh"
                              @smsVerifi="smsVerifiFun"
                              @toBottom="toBottom"
                              @click-table="clickTable"
                              @todo-inside="todoInside"
                              @todo-outside="todoInside"
                              @custom-scene="customScene"
                              @open-dictionary="openDictionary"
                              @to-nav="$emit('to-nav', $event)"
                              v-else
                            ></transactionManagementList> -->
                          </template>
                          <!-- 待阅 -->
                          <oaExamineTables
                            v-else-if="dataInfo.pageId === '3'"
                            @goInfo="goAudit"
                            ref="info"
                            :isMy="true"
                            :initiateArr="listInfo.tableData"
                            :isIndex="4"
                          />
                          <recycleBin :isDoor="true" v-else-if="dataInfo.pageId === '10'" ref="recycleBin" :appid="dataInfo.info.apply.id" />
                          <iframe
                            v-else
                            ref="iframe"
                            frameborder="0"
                            scrolling="auto"
                            :src="iframeUrl"
                            allowtransparency="true"
                          ></iframe>
                        </template>
                        <!-- 视频样式 -->
                        <template v-else-if="dataInfo.info[dataInfo.pageId].pageList.tableStyle === 'video'">
                          <videoForm
                            :appProperty="appProperty"
                            :listInfo="listInfo"
                            :videoInfoConfig="dataInfo.info.videoInfoConfig"
                            @retRefresh="videoFormRefresh"
                          />
                        </template>
                        <!-- 卡片模式 -->
                        <template v-else>
                          <transactionManagementList
                            v-show="false"
                            ref="oneChild"
                            :navIndex="0"
                            :openAction="dataInfo.info[dataInfo.pageId].pageList.openAction"
                            :pageList="dataInfo.info[dataInfo.pageId].pageList"
                            v-model:listInfo="listInfo"
                            :approvalId="dataInfo.info.apply.id"
                            :jurisdiction="jurisdiction"
                            :checkSyllable="tableCheckField"
                            :listTodoField="listTodoField"
                            :pivotConfig="dataInfo.info.pivotConfig"
                            v-model:multipleSelection="multipleSelection"
                            :clickEffect="dataInfo.info.clickEffect"
                            :tableTodoList="dataInfo.info.clientTableTodoList"
                            :rightTodoList="dataInfo.info.rightTodoList"
                            :isGetListData="isGetListData"
                            :aitableHide="aitableHide"
                            @openDataSync="openDataSync"
                            @cardDataDel="cardDataDel"
                            @edit-user-info="editUserInfo"
                            @toBottom="toBottom"
                            @change-currpage="handleChangePageInfo"
                            @goSearch="goListSearch"
                            @click-table="clickTable"
                            @click-row="clickRow"
                            @sourceAudit="sourceAudit"
                            @resetRefresh="resetRefresh"
                            @smsVerifi="smsVerifiFun"
                            @open-dictionary="openDictionary"
                            @to-nav="$emit('to-nav', $event)"
                          ></transactionManagementList>
                          <template v-if="isNewCard">
                            <div class="card">
                              <Card 
                                :listInfo="listInfo" 
                                :minSapcing="dataInfo.info.listStyleConfig.minMargin"
                                :cardConfig="dataInfo.info.cardInfoConfig" 
                                :cardInfo="JSON.stringify(cardConfig) !== '{}' ? cardConfig : dataInfo.info.appListInfo.card"
                                :listTodoConfig="dataInfo.info.tableStyleField.isTodoList ? dataInfo.info.listTodoConfig : []"
                                :initConfig="dataInfo.info.initConfig"
                                :tableStyleField="dataInfo.info.tableStyleField"
                                :defaultPrecent="defaultPrecent"
                                :isGetListData="isGetListData"
                                :customDeskId="customDeskId"
                                :screenRef="$refs.screenRef"
                                ref="cardRef"
                                @appPrint="appPrint"
                                @list-click="handleCardClick" 
                                @openAppInitiate="openAppInitiate"
                                @edit-btn="(val) => { $refs.oneChild.tableUpdate(val); reloadScreen()  }" 
                                @del-btn="(val) => { $refs.oneChild.deleteRow(1, val, 'card'); reloadScreen() }" 
                                @open-appDialog="openAppDialog"
                                @custom-scene="customScene"
                                @edit-user-info="editUserInfo"
                                @toBottom="toBottom"
                                @todo-inside="todoInside"
                                @tableDetail="(data, dataInfo, type)=>{ tableDetail(data, dataInfo, type)}"
                              ></Card>
                            </div>
                            <div class="page-pagination">
                              <el-pagination
                                @size-change="handleChangePageInfo($event, 'pageSize')"
                                @current-change="handleChangePageInfo($event, 'currentPage')"
                                :current-page="listInfo.currentPage"
                                :page-sizes="[25, 50, 100]"
                                layout="total, sizes, prev, pager, next, jumper"
                                :page-size="listInfo.tablePageSize"
                                :total="listInfo.tableTotal"
                                v-if="dataInfo.info.tableStyleField && dataInfo.info.tableStyleField.loadingMethod === 'pageCutting'"
                              /> 
                            </div>
                          </template>
                        </template>
                      </div>
                    </el-main>
                  </template>
                </splitPanel>
              </template>
              <template v-else>
                <el-main class="table-content" v-loading="loading" :style="[getTableBgInfo,{padding:`${ dataInfo.info[dataInfo.pageId].pageList.tableStyle === 'list' ? dataInfo.info.listStyleConfig && dataInfo.info.listStyleConfig.minMargin || 10 : (dataInfo.info.listStyleConfig && dataInfo.info.listStyleConfig.minMargin || 10) / 2 }px` }]" style="padding-bottom: 0;position: relative">
                  <!-- 列表标题 -->
                  <customTitle :info="dataInfo.info.listStyleConfig.titleStyle" v-if="dataInfo.info.tableStyleField.isAppenTitle"/>
                  <!-- 列表模式 -->
                  <template v-if="dataInfo.info.tableStyleField.loadingMethod === 'pageScroll'">
                    <div v-if="listInfo.currentPage > 1" class="page-change-left page-change" @click="scrollChange('prev')">
                      <i class="iconfont icon-shuangjiantouzuo"></i>
                    </div>
                    <div class="page-change-right page-change" v-if="isNextChange" @click="scrollChange('next')">
                      <i class="iconfont icon-shuangjiantouyou"></i>
                    </div>
                  </template>
                  <div style="flex: 1;position: relative; overflow: hidden;">
                    <template v-if="dataInfo.info[dataInfo.pageId].pageList.tableStyle === 'list'">
                      <template v-if="!['3', '8', '9', '10'].includes(dataInfo.pageId)">
                        <vxeTable
                          ref="oneChild"
                          :navIndex="0"
                          :isDoor="true"
                          :customDeskId="customDeskId"
                          :openAction="dataInfo.info[dataInfo.pageId].pageList.openAction"
                          :pageList="dataInfo.info[dataInfo.pageId].pageList"
                          :dataInfo="dataInfo.info"
                          v-model:listInfo="listInfo"
                          :approvalId="dataInfo.info.apply.id"
                          :jurisdiction="jurisdiction"
                          :checkSyllable="tableCheckField"
                          :listTodoField="listTodoField"
                          v-model:multipleParentSelection="multipleSelection"
                          :pageId="dataInfo.pageId"
                          :isGetListData="isGetListData"
                          :aitableHide="aitableHide"
                          :approvalInfo="approval"
                          :loading="loading"
                          :currentOrg="currentOrg"
                          :screenRef="$refs.screenRef"
                          @openDataSync="openDataSync"
                          @edit-user-info="editUserInfo"
                          @appPrint="appPrint"
                          @change-currpage="handleChangePageInfo"
                          @goSearch="goListSearch"
                          @open-appDialog="openAppDialog"
                          @sourceAudit="sourceAudit"
                          @resetRefresh="resetRefresh"
                          @smsVerifi="smsVerifiFun"
                          @toBottom="toBottom"
                          @click-table="clickTable"
                          @todo-inside="todoInside"
                          @todo-outside="todoInside"
                          @custom-scene="customScene"
                          @open-dictionary="openDictionary"
                          @to-nav="$emit('to-nav', $event)"
                          />
                          <!-- v-if="dataInfo.info.apply.id !== 38858"
                        />
                        
                        <transactionManagementList
                          ref="oneChild"
                          :navIndex="0"
                          :isDoor="true"
                          :customDeskId="customDeskId"
                          :openAction="dataInfo.info[dataInfo.pageId].pageList.openAction"
                          :pageList="dataInfo.info[dataInfo.pageId].pageList"
                          :tableStyleField="dataInfo.info.tableStyleField"
                          v-model:listInfo="listInfo"
                          :approvalId="dataInfo.info.apply.id"
                          :jurisdiction="jurisdiction"
                          :checkSyllable="tableCheckField"
                          :listTodoField="listTodoField"
                          :pivotConfig="dataInfo.info.pivotConfig"
                          v-model:multipleSelection="multipleSelection"
                          :clickEffect="dataInfo.info.clickEffect"
                          :tableTodoList="dataInfo.info.clientTableTodoList"
                          :rightTodoList="dataInfo.info.rightTodoList"
                          :pageId="dataInfo.pageId"
                          :listStyleConfig="dataInfo.info.listStyleConfig"
                          :listTodoConfig="dataInfo.info.listTodoConfig"
                          :initConfig="dataInfo.info.initConfig"
                          :titleRowConfig="dataInfo.info.titleRowConfig"
                          :filedWidthList="dataInfo.info.filedWidthList"
                          :isGetListData="isGetListData"
                          :aitableHide="aitableHide"
                          :approvalInfo="approval"
                          @openDataSync="openDataSync"
                          @edit-user-info="editUserInfo"
                          @appPrint="appPrint"
                          @change-currpage="handleChangePageInfo"
                          @goSearch="goListSearch"
                          @open-appDialog="openAppDialog"
                          @sourceAudit="sourceAudit"
                          @resetRefresh="resetRefresh"
                          @smsVerifi="smsVerifiFun"
                          @toBottom="toBottom"
                          @click-table="clickTable"
                          @todo-inside="todoInside"
                          @todo-outside="todoInside"
                          @custom-scene="customScene"
                          @open-dictionary="openDictionary"
                          @to-nav="$emit('to-nav', $event)"
                          v-else
                        ></transactionManagementList> -->
                      </template>
                      <!-- 待阅 -->
                      <oaExamineTables
                        v-else-if="dataInfo.pageId === '3'"
                        @goInfo="goAudit"
                        ref="info"
                        :isMy="true"
                        :initiateArr="listInfo.tableData"
                        :isIndex="4"
                      />
                      <recycleBin :isDoor="true" v-else-if="dataInfo.pageId === '10'" ref="recycleBin" :appid="dataInfo.info.apply.id" />
                      <iframe
                        v-else
                        ref="iframe"
                        frameborder="0"
                        scrolling="auto"
                        :src="iframeUrl"
                        allowtransparency="true"
                      ></iframe>
                    </template>
                    <!-- 视频样式 -->
                    <template v-else-if="dataInfo.info[dataInfo.pageId].pageList.tableStyle === 'video'">
                      <videoForm
                        :appProperty="appProperty"
                        :listInfo="listInfo"
                        :videoInfoConfig="dataInfo.info.videoInfoConfig"
                        @retRefresh="videoFormRefresh"
                      />
                    </template>
                    <!-- 卡片模式 -->
                    <template v-else>
                      <transactionManagementList
                        v-show="false"
                        ref="oneChild"
                        :navIndex="0"
                        :openAction="dataInfo.info[dataInfo.pageId].pageList.openAction"
                        :pageList="dataInfo.info[dataInfo.pageId].pageList"
                        v-model:listInfo="listInfo"
                        :approvalId="dataInfo.info.apply.id"
                        :jurisdiction="jurisdiction"
                        :checkSyllable="tableCheckField"
                        :listTodoField="listTodoField"
                        :pivotConfig="dataInfo.info.pivotConfig"
                        v-model:multipleSelection="multipleSelection"
                        :clickEffect="dataInfo.info.clickEffect"
                        :tableTodoList="dataInfo.info.clientTableTodoList"
                        :rightTodoList="dataInfo.info.rightTodoList"
                        :initConfig="dataInfo.info.initConfig"
                        :titleRowConfig="dataInfo.info.titleRowConfig"
                        :isGetListData="isGetListData"
                        :filedWidthList="dataInfo.info.filedWidthList"
                        :aitableHide="aitableHide"
                        @cardDataDel="cardDataDel"
                        @toBottom="toBottom"
                        @edit-user-info="editUserInfo"
                        @change-currpage="handleChangePageInfo"
                        @goSearch="goListSearch"
                        @click-table="clickTable"
                        @sourceAudit="sourceAudit"
                        @resetRefresh="resetRefresh"
                        @smsVerifi="smsVerifiFun"
                        @open-dictionary="openDictionary"
                        @to-nav="$emit('to-nav', $event)"
                      ></transactionManagementList>
                      <template v-if="isNewCard">
                        <div class="card" :style="{ paddingBottom: dataInfo.info.tableStyleField && dataInfo.info.tableStyleField.loadingMethod === 'pageCutting' ? '40px' : '' }">
                          <Card 
                            :listInfo="listInfo" 
                            :minSapcing="dataInfo.info.listStyleConfig.minMargin"
                            :cardConfig="dataInfo.info.cardInfoConfig" 
                            :cardInfo="JSON.stringify(cardConfig) !== '{}' ? cardConfig : dataInfo.info.appListInfo.card"
                            :listTodoConfig="dataInfo.info.tableStyleField.isTodoList ? dataInfo.info.listTodoConfig : []"
                            :initConfig="dataInfo.info.initConfig"
                            :tableStyleField="dataInfo.info.tableStyleField"
                            :defaultPrecent="defaultPrecent"
                            :isGetListData="isGetListData"
                            :customDeskId="customDeskId"
                            :screenRef="$refs.screenRef"
                            ref="cardRef"
                            @appPrint="appPrint"
                            @list-click="handleCardClick" 
                            @openAppInitiate="openAppInitiate"
                            @edit-btn="(val) => { $refs.oneChild.tableUpdate(val) }" 
                            @del-btn="(val) => { $refs.oneChild.deleteRow(1, val, 'card') }" 
                            @open-appDialog="openAppDialog"
                            @custom-scene="customScene"
                            @edit-user-info="editUserInfo"
                            @toBottom="toBottom"
                            @todo-inside="todoInside"
                            @tableDetail="(data, dataInfo, type)=>{ tableDetail(data, dataInfo, type)}"
                          ></Card>
                        </div>
                        <div class="page-pagination">
                          <el-pagination
                            @size-change="handleChangePageInfo($event, 'pageSize')"
                            @current-change="handleChangePageInfo($event, 'currentPage')"
                            :current-page="listInfo.currentPage"
                            :page-sizes="[25, 50, 100]"
                            layout="total, sizes, prev, pager, next, jumper"
                            :page-size="listInfo.tablePageSize"
                            :total="listInfo.tableTotal"
                            v-if="dataInfo.info.tableStyleField && dataInfo.info.tableStyleField.loadingMethod === 'pageCutting'"
                          /> 
                        </div>
                      </template>
                    </template>
                  </div>
                </el-main>
              </template>
            </div>
          </div>
          <!-- 没有权限时显示的内容 -->
          <template v-if="!(isPower && validateType === 4)">
            <template v-if="validateType === 1">
              <div class="no-power">
                <img
                  src="https://bigdata.topeti.com/PCRepository/defaultSvg/NoAccessRights.svg"
                  class="no-power-img"
                />
                <!-- <h2 class="no-power-tips" v-if="dataInfo.pageId === '6'">
                  未设置管辖数据,请设置后查看
                </h2> -->
              </div>
            </template>
            <template v-else-if="validateType === 2 || toVeriQueryShow == true">
              <VerificationAndQueryInput
                ref="VerificationAndQueryInputRef"
                :approvalId="dataInfo.info.apply.id"
                :number="validatePage"
                 v-loading="loading"
                @toVerificationAndQuery="formVerificationAndQuery"
              />
            </template>
            <smsVerifiction
              ref="smsVerifi"
              :approvalId="dataInfo.info.apply.id"
              type="1"
              @smsRefersh="smsRefersh"
              v-show="validateType === 3 && toSmsVerifi == true"
            />
          </template>
        </el-container>
      </el-container>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
      v-model="isInput"
      :append-to-body="true"
      :destroy-on-close="true"
      :show-close="false"
      :close-on-click-modal="false"
      :class="pdheight== 'auto' ? 'application-routing-dialog-all dialog-height-auto' : 'application-routing-dialog-all'"
      :fullscreen="routingFlowshow"
      :top="routingFlowshow ? '0' : '8.9vh'"
      :width="routingFlowshow ? '100%' : (pdwidth + '%')"
    >
      <div class="dialog-top">
        <div class="apply-name">{{ dataInfo.name }}</div>
        <div class="apply-right">
          <div v-if="isAi">
            <span class="active-hover" @click="upIsAi(isAi === 1 ? 2 : 1)">
              <img src="https://bigdata.topeti.com/PCRepository/mainPlatform/ai.png" style="width:25px;height:25px;vertical-align: inherit;margin-right:4px;" />
              AI小易
            </span>
          </div>
          <div v-if="flowshow != 2 && !modify">
            <span class="active-hover" @click="onFlowshow">
              <i class="el-icon-view" />
              {{ getFlowShowText() }}
            </span>
          </div>
          <div>
            <span
              class="active-hover"
              style="margin-right: 5px"
              @click="routingFlowshow = !routingFlowshow"
            >
              <i
                v-show="!routingFlowshow"
                class="iconfont icon-fangda2"
                style="font-size: 14px"
              />
              <i
                v-show="routingFlowshow"
                class="iconfont icon-suoxiao1"
                style="font-size: 14px"
              />
            </span>
            <span class="active-hover" @click="isInput = false">
              <i class="icon iconfont icon-shanchu3" />
            </span>
          </div>
        </div>
      </div>
      <oaExamineInput
        :approvalId="dataInfo.info.apply.id"
        :modify="modify"
        :person="(dataInfo.pageId === '6' || dataInfo.pageId === '7') ? 0 : 1"
        :pageId="dataInfo.pageId"
        v-model:isAi="isAi"
        v-model:pdwidth="pdwidth"
        :isReadonlyDetails="isReadonlyDetails"
        :isAppenDetailsFeild="isAppenDetailsFeild"
        :pageType="pageType"
        type="1"
        ref="AuditOpenInput"
        @refFlowshow="refFlowshow"
        @retRefresh="retRefresh"
        @inputClose="inputClose"
        @upIsAi="upIsAi"
        @upIsPcwidth="upIsPcwidth"
        @upIsPcHeight="upIsPcHeight"
        @upBaseset="upBaseset"
        v-if="isInput"
      />
    </el-dialog>
    <oaExamineAudit ref="AuditOpenChild"></oaExamineAudit>
    <app-dialog 
      :dialogInfo="dialogInfo"
      :iId="openInput.iId"
      v-model:isDetail="openInput.isDetail"
      :appId="openInput.approvalId"
      v-model:addInputShow="openAddInputShow"
      :coverVal="openInput.search"
      :datatype="openInput.datatype"
      @doorUp="doorUp"
      @close="doorUpCloe" />
    <upOption ref="upOption"></upOption>
    <oaAuditPrinting ref="oaAuditPrintingChild"></oaAuditPrinting>
    <exportProgress v-model:isView="isProgressView" :isClose="isProgress" @closed="isProgress = false" />
    <editUserInfoDrawer @close="closeDataSync" v-model:isView="isShowEidtUser" :userInfo="userInfo" @confirm="confirmEditUserInfo" :editUserInfoConfig="editUserInfoConfig" :editUserInfoKey="editUserInfoKey" />
    <check-field ref="checkField" @checkField="checkField" :tableStyleField="dataInfo.info.tableStyleField" />
    <dataSync ref="dataSync" @close="closeDataSync" @upLimit="upLimit" />
    <dataSyncInit ref="dataSyncInit" @confirm="dataSyncInitConfirm" />
  </div>
</template>

<script>
import qs from 'qs'
import { axiosBase } from '@/api/api'
import { objectToTree } from "@/components/clientSide/instrument/utils/getConfig";
import { momVal, copyObj, setOthersFormdata, assignFormdata, othersRed, getConfigFromUrl } from '@/api/utils'
import { oaAuditPrintingFunc } from '@/api/index'
import { cloneDeep } from 'lodash'
import { openapiUpdateuserccapproving } from '@/api/index'
import { timeFormatDate, formatDate, getOrgShowName, filePreview } from "@/api/global";  //阅读待阅数据请求
import { isValidateapprovaltimeswitch, getToolBgInfo, dealScreenOpt, getPageSize, isObject, treeExpandOrFold, getBottomLayerId } from '@/components/schoolInstrument/mixins/utils'
import { getRandom } from '@/util/util'
import parmsMixins from '@/components/schoolInstrument/mixins/parmsMixins'
import { getDataSyncConfig } from './common/config'

// 接口
import { getopenorganizationlist, getopenuserlist, getopenrolelist } from '@/port/clientSide/multipleChoice'
import { openapiGetapprovalnum, openapiGetapproval } from '@/port/clientSide/applicationRouting.js'
import { openapiGetuserapprovinglist, getapprovingfilecontent } from '@/port/clientSide/oaExamine.js'
import { datasyncform } from '@/port/schoolInstrument/appConfig.js'
import { updateapprovingbyfeild } from "@/port/clientSide/oaExamineAudit";
import { getopenreportformlist, openapiValidateapprovalsms, getvalidateapproval, getapprovalcontent, getapprovalreportpreview } from '@/port/clientSide/workbench'

// 组件
import transactionManagementList from '@/components/clientSide/workbench/transactionManagementList'
import bigSearch from './component/search/bigSearch'
import screenBtn from './component/button/screenBtn.vue'
import splitScreen from './component/form/splitScreen.vue'
import splitPanel from '@/components/common/splitPanel'
import oaExamineTables from '@/views/clientSide/oaExamine/components/oaExamineTable.vue'
import oaExamineAudit from '@/components/clientSide/oaExamineAudit.vue'
import oaAuditPrinting from "@/components/clientSide/oaAuditPrinting";
import Card from '@/components/common/card/card.vue'
import recycleBin from '@/components/clientSide/workbench/recycleBin.vue'
import checkField from '@/components/schoolInstrument/common/checkField'
import organizationList from '@/components/schoolInstrument/common/organizationList.vue'
import dataSync from '@/components/schoolInstrument/common/dataSync.vue'
import dataSyncInit from '@/components/schoolInstrument/common/dataSyncInit.vue'

// 公共函数/对象
import { typeObj } from '@/util/constants'
import common from './common/common'
import { isConditionAppen, getScreenRectInfo, dealFixQuery, isAdaption, getResValue, extractChinese } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { setFormulaValue } from '@/components/schoolInstrument/component/mutual/common/formula.js'
import DealPrintData from '@/components/common/detailEdit/utils/dealPrintData.utils.js'
import vxeTable from './component/form/vxeTable.vue'
import { defineAsyncComponent } from 'vue'
import { showMyDialog } from "@/components/clientSide/workbench/bulkImportCpn/uploadDialog.js";
import { dealText } from '@/api/common'

export default {
  name: 'mutial-index',
  mixins: [common, parmsMixins],
  props: {
    dataInfo: {
      type: Object,
      default: ()=>({}),
    },
    index: {
      type: Number
    },
    themeColor: {
      type: String,
      default: '#4e86ff'
    },
    cardConfig: {
      type: Object,
      default: () => ({}),
    },
    organizationType: {
      type: Array,
      default:()=>([])
    },
    customDeskId: {
      type: [Number, String],
      default: 0,
    },
    isAppDesign: {
      type: Boolean,
      default: false,
    },
    aitableHide: {
      type: Boolean,
      default: false,
    }
  },
  inject: {
    customDeskInfo: { value: "customDeskInfo", default: null }
  },
  components: {
    buttonComp: defineAsyncComponent(() => import('./component/button')),
    searchComp: defineAsyncComponent(() => import('./component/search')),
    screenComp: defineAsyncComponent(() => import('./component/screen')),
    customTitle: defineAsyncComponent(() => import('./component/form/customTitle')),
    oaExamineInput: defineAsyncComponent(() => import('@/components/clientSide/oaExamineInput.vue')),
    VerificationAndQueryInput: defineAsyncComponent(() => import('@/components/clientSide/VerificationAndQueryInput')),
    smsVerifiction: defineAsyncComponent(() => import('@/components/clientSide/common/smsVerifiction.vue')),
    bigSearch,
    transactionManagementList,
    oaExamineTables,
    oaExamineAudit,
    screenBtn,
    splitScreen,
    recycleBin,
    AppDialog: defineAsyncComponent(() => import('@/components/schoolInstrument/mixins/AppDialog.vue')),
    videoForm: defineAsyncComponent(() => import('./component/form/videoForm.vue')),
    Card,
    upOption: defineAsyncComponent(() => import('@/components/schoolInstrument/mixins/upOption.vue')),
    exportProgress: defineAsyncComponent(() => import('@/components/common/exportProgress')),
    splitPanel,
    oaAuditPrinting,
    editUserInfoDrawer: defineAsyncComponent(() => import('@/components/admins/organization/common/editUserInfo')),
    vxeTable,
    organizationList,
    checkField,
    dataSync,
    dataSyncInit,
  },
  beforeDestory() {
    if (this.refreshTime) {
      this.refreshTime = null
    }
  },
  computed: {
    tableCheckField() {
      const { tableStyleField, pivotConfig, checkSyllable } = this.dataInfo.info
      if (tableStyleField && tableStyleField.filedType === 'pivot' && pivotConfig) {
        if (pivotConfig.customField && pivotConfig.customField.length) {
          const name = pivotConfig.customField[0].fatherType.split('_')[0]
          const idx = pivotConfig.checkFile.findIndex(item => item.name === name)
          if (idx !== -1) {
            const li = cloneDeep(pivotConfig.checkFile)
            li.splice(idx, 0, ...pivotConfig.customField)
            return li.filter(item => item.checked)
          } else {
            return [...pivotConfig.checkFile, ...pivotConfig.customField].filter(item => item.checked)
          }
        }
        const li = pivotConfig.checkFile || []
        return li.filter(item => item.checked)
      } else {
        return checkSyllable
      }
    },
    isShowLastUser() {
      return this.organizationalStructure.showLastUser === 'open'
    },
    isInitTable(){
      return this.dataInfo.info.tableStyleField.isInitTable === false
    },
    isGradedManagement() {
      return this.organizationalStructure.administrationOrg === 'open'
    },
    isOpenOrg() {
      return this.organizationalStructure && this.organizationalStructure.organizationNav === 'open' && (Object.keys(this.powerData['1']).length || Object.keys(this.powerData['0']).length)
    },
    splitScreenInfo() {
      return this.dataInfo.info.splitScreenInfo || {}
    },
    isInitTableAndOpenScreen() {
      if (!this.dataInfo.info.tableStyleField || !this.dataInfo.info.initConfig) return false
      // 开启了筛选后初始化
      const isInit = this.isInitTable
      // 并且配置了 筛选器
      const isList = this.dataInfo.info.initConfig.list.length > 0
      // 并且开启了分屏 并且分屏没有隐藏
      let isOpen = false
      if (this.splitScreenInfo.config && this.splitScreenInfo.config.splitInfo && this.splitScreenInfo.config.splitInfo.screenAppen === 'open') {
        isOpen = true
      }
      return isInit && isList && isOpen && this.initCount === 0
    },
    organizationalStructure() {
      return this.dataInfo.info.organizationalStructure
    },
    splitPanelSlot () {
      const left = this.splitScreenInfo.left
      if (left === 'screen') {
        return 'paneF'
      } else {
        return 'paneS'
      }
    },
    oppSplitPanelSlot () {
      return this.splitPanelSlot === 'paneS' ? 'paneF' : 'paneS'
    },
    isAppenScreen () {
      const { config = {} } = this.splitScreenInfo
      if (config.splitInfo && config.splitInfo.screenAppen === 'hidden') {
        return false
      }
      return true
    },
    isAppenList () {
      const { config = {} } = this.splitScreenInfo
      if (config.splitInfo && config.splitInfo.listAppen === 'hidden') {
        return false
      }
      return true
    },
    splitInfoComp () {
      const obj = {
        defaultPrecent: 50,
        direction: 'level',
        minPercent: 0,
        maxPercent: 0
      }
      const { config = {} } = this.splitScreenInfo
      if (this.isInitTableAndOpenScreen) {
        if (this.splitPanelSlot === 'paneF') {
          obj.defaultPrecent = 0
        } else {
          obj.defaultPrecent = 100
        }
      } else {
        obj.defaultPrecent = this.defaultPrecent
      }
      if (config.splitInfo) {
        const { listAppen, screenAppen, structure } = config.splitInfo
        if (structure === 'leftAndRight') {
          obj.direction = 'vertical'
        }
        if (listAppen === 'hidden' || listAppen === 'close') {
          if (this.splitPanelSlot === 'paneF') {
            obj.defaultPrecent = 100
          } else {
            obj.defaultPrecent = 0
          }
        }
        if (screenAppen === 'hidden' || screenAppen === 'close') {
          // 分屏在左边
          if (this.splitPanelSlot === 'paneF') {
            obj.defaultPrecent = 0
          } else {
            obj.defaultPrecent = 100
          }
        }
      }
      return obj
    },
    isNextChange() {
      const cur = this.listInfo.currentPage
      const pagesize = this.listInfo.tablePageSize
      const total = this.listInfo.tableTotal
      return cur * pagesize < total
    },
    leftListLayout () {
      return this.layout.filter(item => item.position === 'left') || []
    },
    topListLayout () {
      return this.layout.filter(item => item.position !== 'left') || []
    },
    getMaxWidth() {
      if (!this.dataInfo.info.tableStyleField) return
      const { saveArea, customArea } = this.dataInfo.info.tableStyleField
      if (saveArea) {
        let maxWidth = ''
        const cusObj = {
          all: 0,
          two: 208
        }
        const [type, vals] = saveArea.split('-')
        if (vals === 'custom') {
          // 自定义
          maxWidth = customArea - cusObj[type]
        } else {
          maxWidth = vals
        }
        return `${maxWidth}px`
      } else {
        return ''
      }
    },
    isTowColumn() {
      if (!this.dataInfo.info.tableStyleField) return
      const { saveArea } = this.dataInfo.info.tableStyleField
      let flag = false
      if (saveArea) {
        const [type] = saveArea.split('-')
        flag = type === 'two'
      }
      return flag
    },
    screenNum() {
      let screenArr = []
      this.layout.forEach(item => {
        if (Array.isArray(item.info)) {
          const key = this.getKey(item)
          const arr = item[key].filter(f => f.type === 'screen' && f.checkName)
          screenArr.push(...arr)
        }
      })
      return screenArr.length
    },
    getScreen(){
      const screenArr = []
      this.layout.forEach(item => {
        if (Array.isArray(item.info)) {
          const key = this.getKey(item)
          item[key].forEach(citem => {
            // 只有筛选组件有可能有默认值  所以按钮组件不考虑
            if (citem.type === 'screen') {
              screenArr.push(citem)
            }
          })
        }
      })
      return screenArr
    },
    getBgInfo() {
      const listStyleConfig = this.dataInfo.info.listStyleConfig
      if (!listStyleConfig) return
      const { bgTransparent, bgfllStyle } = listStyleConfig
      if (bgTransparent) {
        return {
          background: 'transparent'
        }
      }
      return getToolBgInfo(bgfllStyle)
    },
    getTableBgInfo() {
      const listStyleConfig = this.dataInfo.info.listStyleConfig
      if (!listStyleConfig) return
      const { tablefllStyle } = listStyleConfig
      return getToolBgInfo(tablefllStyle)
    },
    getBoxShadowInfo () {
      const listStyleConfig = this.dataInfo.info.listStyleConfig
      if (!listStyleConfig) return
      const { boxShadow } = listStyleConfig
      if (!boxShadow) {
        return {
          boxShadow: '2px 2px 8px 0px rgba(186,186,186,0.5)'
        }
      } else {
        return ''
      }
    },
    getIdScreenRef () {
      const idScreenRef = {}
      this.$refs.screenRef.forEach(item => {
        if (item.info) {
          idScreenRef[item.info.i] = item
        }
      })
      return idScreenRef
    },
    stopInitScreenList () {
      // 存在值再筛选的筛选列表
      let list = []
      if (this.dataInfo.info) {
        const { info } = this.dataInfo
        if (info.tableStyleField.isInitTable === false && info.initConfig) {
          list = info.initConfig.list
        }
      }
      return list
    },
    isAiDrop () {
      let flag = false
      if (this.dataInfo.info) {
        const { info } = this.dataInfo
        if (info.tableStyleField.isAiImport  && info.tableStyleField.aiImportBtnId) {
          flag = true
        }
      }
      return flag
    },
    importBtns () {
      const resultList = []
      this.layout.forEach(list => {
        list.info.forEach(item => {
          if (item.type === 'button' && item.info && item.info.bindingFunction === 'all-in-custom') {
            const btn = cloneDeep(item)
            if (!btn.info.text) {
              btn.info.text = '自定义数据导入'
            }
            resultList.push(btn)
          }
        })
      })
      return resultList
    },
    aiDropBtn () {
      let btnRef = null
      if (this.isAiDrop) {
        btnRef = this.$refs.buttonRef.find(item => { return item.info.i === this.dataInfo.info.tableStyleField.aiImportBtnId })
      }
      return btnRef
    },
    aiDropBtnTips () {
      let text = ''
      if (this.aiDropBtn) {
        text = this.aiDropBtn.info.info.allInCustomInfo.aiTips
        text = dealText({
          text,
          commonData: this.$store.state.userData,
          customData: this.$store.state.doorCustomDataObj[this.customDeskId] || this.$store.state.doorCustomData
        })
      }
      return text
    },
  },
  data () {
    return {
      isOrgOpen: false,
      titleQeury:{},
      titleOrder:[],
      dialogInfo: {
        dialogName: '',
        isVisible: false,
        dialogWidth: '80%',
        dialogHeight: '85vh',
        openType: 'dialog',
        customSize: 65,
        dialogUrl: '',
        diaSize: '80%',
        childDialog: true
      },
      isPageChange: false,
      isNewCard: true,
      isAi: 0,
      pdwidth: 75,
      pdheight: 'regular',
      // 获取权限数据
      powerData: {
        '1': {},
        '0': {}
      },
      // 补坑需要的东西 我快疯了~~
      resetAllData: {},
      jurisdictionData: [],
      //  列表数据的信息
      listInfo: {
        tableData: [],
        tableTotal: 0,
        currentPage: 1,
        tablePageSize: 25,
      },
      originalData: [],
      dataList: [],
      //  girdItem遍历的数组
      layout: [],
      //  列表模式checkbox选中的数据
      multipleSelection: [],
      blockchainChange: false,
      routingFlowshow: false, //放大 缩小
      isInput: false,
      flowshow: 2,
      jurisdiction: {}, //带userId表示个人 不带表示全部数据
      // 筛选条件显示
      searchCriteria: {
        query: null
      },
      // 判断是页面权限
      pagePower: {
        // 个人数据权限
        personData: {},
        // 管辖数据权限
        scopenData: {},
        // 全部数据权限
        allData: {},
        // 填写表单权限
        writeTable: {}
      },
      // 判断有无权限是否显示
      isPower: true,
      // 需要验证的页面
      validatePage: 1,
      // 是否显示验证弹窗
      toVeriQueryShow: true,
      // 判断验证的类型，1为数据验证 2为表单验证 3为短信验证 4为通过
      validateType: 4,
      toSmsVerifi: true,
      // 提交统计和区块链统计的url 显示iframeUrl
      iframeUrl: '',
      isShowMenu: false,
      querys: {},
      searchQuery: {},
      openInput: {
        isVisible: false,
        approvalId: '',
        search: {},
        iId: '',
      },
      detailInfo: {},
      openAddInputShow: false, // 发起单独使用的
      loading: false,
      organizationalParameters:{},
      searchText: '',
      // 搜索组件选择了字段 需要的query
      searchCompQuery:{},
      isSearchStatus:false,
      isNoList: false,
      // 当前选择的组织名称和组织id
      currentOrg: {},
      // 当前选择的联系人
      currentUser: {},
      // 弹窗
      popUps: false,
      popUpsObj: {
        popUps: {},
        url:''
      },
      ruledata: {},
      spaceid:this.$route.query.spaceid,
      upaceid:this.$route.query.upaceid,
      // 仪表盘搜索专用
      searchYb: {},
      // 筛选组件专用
      screenSearch: {},
      screenFixQuery: {},
      screenQuery: {},
      filterValueQuery: {},
      isProgress: false,
      isProgressView: false,
      isSpace: false, // 是否从空间进入
      agencyNum: 0,
      fillReportNum: 0,
      toBeRead: 0,
      totalParams: {
        key: '',
        query: {},
        params: {},
        ruledata: {},
        status: ''
      },
      noChangeScreenId: -1,
      // 用来记录自定义状态的筛选值
      customStatusQuery: {
        step: []
      },
      addConfig: {
        formdata: [],
        property: []
      },
      defaultPrecent: 50,
      customParams: [],
      // 本表数据的 approval接口数据
      approval: {},
      defaultPrintShowKey: {},
      // 关闭了数据初始化 判断是否需要去请求数据
      isGetListData: false,
      initList: [],
      // 用来判断是否为初始化  主要是因为欧总想要打开分屏所加的参数
      initCount: 0,
      baseSet:{
        grouping: 0, // 0：当前用户 1：当前应用
        flowshow: {
          type: 'merge',
          width: '345px'
        }
      }, // 流程设置新增的JSON
      orgList: [],
      appProperty: [],
      refreshTimer: null,
      isReadonlyDetails: false,
      isAppenDetailsFeild: [],
      screenRelation: {}, // 筛选组件之间的关联
      listTodoField: {}, // 列表页面的筛选字段
      importData: [],
      originalList: [],
      isDrop: false,
      importConfig: {},
      isFirstInitScreenCount: 0, // 是否第一次筛选出来请求
      isSearchScreenValue: {}
    }
  },
  watch: {
    themeColor: {
      handler (val) {
        this.$nextTick(() => {
          this.$refs.mutualIndex.style.setProperty('--theme-color', val)
        })
      },
      immediate: true
    },
    cardConfig: {
      handler () {
        if (this.dataInfo.info.pages && this.dataInfo.info.pages.length !== 0) {
          // 刚开始请求权限数据。
          this.hanldePower()
        }
        this.layout = this.dataInfo.info[this.dataInfo.pageId].layout
      },
      deep: true
    },
    'dataInfo.pageId': {
      async handler(newVal) {
        const vali = {
          1: 2,
          2: 2,
          3: 2,
          4: 2,
          5: 2,
          6: 4,
          7: 3,
        }
        const flag = await this.isValidateapprovaltimeswitch(vali[this.dataInfo.pageId])
        this.loading = true
        if (flag) return
        const { pages, tableStyleField } = this.dataInfo.info
        if (pages && pages.length !== 0) {
          // 如果传过来的page的长度为0是，则不需要执行任何东西，显示一块白板就好
          if (newVal === '1' || newVal === '6' || newVal === '7') {
            // 由于权限问题，请求数据前需要判断是否有权限
            this.validateType = 1
            this.handlePowerPage(newVal)
          } else if(newVal === '10') {
            this.handleListInfo(this.dataInfo.pageId, '', this.searchCriteria.query || {})
          } else {
            this.isPower = true
            this.validateType = 4
          }
          // if (!this.isPower && this.validateType !== 4) return;
          this.listInfo = {
            tableData: [],
            tableTotal: 0,
            currentPage: 1,
            tablePageSize: 25,
          }
          if (tableStyleField && tableStyleField.pageNum) {
            this.listInfo.tablePageSize = getPageSize(tableStyleField, 25)
          }
          if(this.dataInfo.info[newVal]) {
            this.layout = this.dataInfo.info[newVal].layout
          }
          let flag = true
          flag = this.dealScreenOpt(this.getScreen)
          if (flag) {
            await this.handleListInfo(newVal)
          }
          this.loading = false
          this.querys = {}
          this.isNoList = false
          
        }
      },
    },
    'dataInfo.info.navbarConfig.action': {
      handler (val) {
        if (val === 'close') {
          this.isShowMenu = false
          this.$nextTick(() => {
            this.closeMenu(this.dataInfo.info.navbarConfig.position)
          })
        } else if (val === 'open') {
          this.isShowMenu = true
          this.$nextTick(() => {
            this.closeMenu(this.dataInfo.info.navbarConfig.position)
          })
        }
      },
      immediate: true
    },
    'dataInfo.info.appListInfo.card': {
      handler (val) {
        // activeConfig 不存在就是旧的卡片模式
        if (val && val.activeConfig === undefined && this.cardConfig && this.cardConfig.activeConfig === undefined) {
          this.isNewCard = false
        }
      },
      immediate: true
    },
  },
  async created() {
    let query = this.$route.query
    if (this.customDeskInfo) {
      query = {
        ...query,
        ...this.customDeskInfo
      }
    }
    const spaceId = this.$route.query.spaceid
    const spaceStatus = this.$route.query.space
    if (typeof(spaceId) !== 'undefined' || spaceStatus){
      this.isSpace = true
    }
    this.loading = true
    const iId = query.iId
    if (iId && Number(iId) <= 7) {
      this.$nextTick(() => {
        // eslint-disable-next-line vue/no-mutating-props
        this.dataInfo.pageId = iId
      })
    }
    let search = {}
    try {
      search = this.dealQueryStr(this.$route.query.search)
      if (this.customDeskInfo) {
        const customSearch = this.dealQueryStr(this.customDeskInfo.search)
        search = {
          ...search,
          ...customSearch
        }
      }
    } catch (e) { 
      const url = decodeURIComponent(window.location.href)
      const que = url.split('?')[1]
      let searchStr = que.slice(que.indexOf('search'), que.length)
      search = JSON.parse(searchStr.split('=')[1])
    }
    if (query.search && query.isAll) {
      // const search = JSON.parse(this.$route.query.search)
      const obs = {}
      const approvalId = Number(this.$route.query.approvalId)
      for (const i of search.relevanceRules) {
        if (Number(i.formid) === approvalId && i.datas && i.datas.length > 0) {
          for (const a of i.datas) {
            if (a.target && a.target !== '申请人_relation-user' && a.target !== '单号_text') {
              // 状态、提交时间、归档状态格式不太一样，转化以下
              const obj = {
                '状态_status': 'status_status',
                '提交时间_date': 'date_timeof',
                '归档状态_status': 'archive_radio'
              }
              const target = obj[a.target] || a.target
              const val = Array.isArray(a.value) ? a.value : [a.value]
              obs[target] = val
            }
          }
        }
      }
      this.searchCriteria.query = JSON.stringify(obs)
      // this.otherSearch.query = JSON.stringify(obs)
      this.searchQuery = obs
    } else if (query.search) { // && query.iId
      // 这个代表是仪表盘过来的
      // const search = JSON.parse(this.$route.query.search)
      const obs = {}
      const obj = {
        '归档状态_status': 'archive_radio',
        '申请人_relation-user': 'appuser_appuser'
      }
      const statusObj = {
        '待审批': 0,
        '已通过': 1,
        '未通过': 2,
        '已撤回': 3
      }
      for (const i in search) {
        const val = Array.isArray(search[i]) ? search[i] : [search[i]]
        // 数字值处理下
        if (i === 'status_status') {
          for (let s = 0; s < val.length; s++) {
            val[s] = statusObj[val[s]] || val[s]
          }
        } else if (i === 'date_timeof') {
          for (let s = 0; s < val.length; s++) {
            val[s] = timeFormatDate(new Date(val[s]).getTime())
          }
          if (val.length === 1) {
            val.push(val[0])
          }
        }
        if (obj[i]) {
          obs[obj[i]] = val
        } else {
          obs[i] = val
        }
      }
      this.searchCriteria.query = JSON.stringify(obs)
      // this.otherSearch.query = JSON.stringify(obs)
      this.searchQuery = obs
    }
    const vali = {
      1: 2,
      2: 2,
      3: 2,
      4: 2,
      5: 2,
      6: 4,
      7: 3,
    }
    const flag = await this.isValidateapprovaltimeswitch(vali[this.dataInfo.pageId])
    if (flag) return
    const { pages, tableStyleField } = this.dataInfo.info
    if (pages && pages.length !== 0) {
      // 刚开始请求权限数据。头部有search 就默认去找一下（给仪表盘跳转过来使用）
      this.hanldePower(JSON.stringify(this.searchQuery) !== '{}' ? JSON.stringify(this.searchQuery) : '')
    }
    this.layout = this.dataInfo.info[this.dataInfo.pageId].layout
    this.getScreenRelation()
    if (tableStyleField && tableStyleField.pageNum) {
      this.listInfo.tablePageSize = getPageSize(tableStyleField, 25)
    }
  },
  mounted () {
    this.$nextTick(() => {
      setTimeout(() => {
        this.resetAllData = cloneDeep(this.dataInfo)
      }, 1000);
    })
    if (this.isAiDrop) {
      // ai文件拖入导入
      this.$refs.mutualIndex.addEventListener('dragover', this.handleDragOver);
    }
  },
  unMounted () {
    if (this.$refs.mutualIndex) {
      this.$refs.mutualIndex.removeEventListener('dragover', this.handleDragOver);
    }
  },
  methods: {
    closeDataSync() {
      this.handleListInfo(this.dataInfo.pageId, '', this.querys)
    },
    confirmEditUserInfo(val) {
      const linked = this.editUserInfoConfig.linked || []
      if (linked.length > 0) {
        const fns = []
        for (const ele of linked) {
          const preview = this.userRowInfo[ele.conditionValue.split('_')[0]]
          let value = ''
          if (preview) {
            value = `${preview},${val[ele.userName]}`
           } else {
            value = val[ele.userName]
           }
          const obj = {
            approvalId: this.dataInfo.info.apply.id || this.dataInfo.info.apply.approvalId,
            approvingId: this.userRowInfo.approvingId,
            feild: ele.conditionValue,
            value
          }
          fns.push(updateapprovingbyfeild(obj))
        }
        Promise.all(fns).then(() => {
          this.handleListInfo(this.dataInfo.pageId, '', this.querys)
        })
      }
    },
    upLimit(config) {
      this.$refs.dataSyncInit.open(config)
    },
    async openDataSync(info, row) {
      const dataSyncConfig = info.dataSyncConfig
      // const config = {}
      if (dataSyncConfig) {
        const param = getDataSyncConfig(dataSyncConfig, this.dataInfo.info.apply)
        let query = {}
        if (row) {
          const linked = dataSyncConfig.link.from || []
          const customize = dataSyncConfig.link.customize || []
          const res = await this.getObs({ linked, customize, appId: dataSyncConfig.source.appId, datatype: dataSyncConfig.source.datatype }, row)
          if (dataSyncConfig.source.datatype === 1) {
            if (res.obs && Object.keys(res.obs).length > 0) {
              for (const key in res.obs) {
                const value = res.obs[key]
                if (!Array.isArray(value)) {
                  res.obs[key] = [value]
                }
              }
            }
            query = res.obs
          } else {
            const obj = {}
            for (const key in res.obs) {
              const value = res.obs[key]
              const title = key.split('_')[0]
              const control = dataSyncConfig.source.fields.find(f=> f.title === title)
              if (control) {
                obj[control.name] = value 
              }  
            }
            query = obj
          }
        }
        const params = { syncConfig: param, syncstatus: 0 }
        if (query && Object.keys(query).length > 0) {
          params.query = query
        }
        const res = await datasyncform(params)
        if (res.code === 0) {
          const count = res.total
          if (count > dataSyncConfig.maxSyncNum) {
            this.$refs.dataSync.open({ upperLimit: true, info: {}, dataSyncConfig, count, appInfo: this.dataInfo.info.apply, query })
          } else {
            this.$refs.dataSyncInit.open({ dataSyncConfig , count, appInfo: this.dataInfo.info.apply, query })
          }
        }
      }
    },
    dataSyncInitConfirm(config = {}) {
      this.$refs.dataSync.open(config)
    },
    async exportPivot(val) {
      await this.getPivotDataInfo(this.totalParams, { isExport: true, exportInfo: val })
    },
    aiDropConfirm (data, importType) {
      if (data && this.aiDropBtn) {
        if (importType === 'file') {
          this.aiDropBtn.goCustomImport(null, data)
        } else {
          this.aiDropBtn.goCustomImport(data)
        }
      }
    },
    handleDragOver(event) {
      event.dataTransfer.dropEffect = 'copy'; // 设置拖放效果为复制
      if (!this.isDrop) {
        this.isDrop = true
        const that = this
        let importType = 'table'
        if (this.aiDropBtn && this.aiDropBtn.info.info.allInCustomInfo) {
          const allInCustomInfo = this.aiDropBtn.info.info.allInCustomInfo
          importType = allInCustomInfo.importType
        }
        const uploadDialog = showMyDialog({
          approvalId: that.approval.approvalId || that.approval.id,
          aiTips: that.aiDropBtnTips,
          importType: importType,
          onConfirm: (data) => {
            that.aiDropConfirm(data, importType)
            uploadDialog.destroy();
            that.isDrop = false
          },
          onCancel: () => {
            uploadDialog.destroy();
            that.isDrop = false
          }
        }, 'aiDropUpload')
      }
      event.preventDefault()
    },
    setOrgList(val) {
      this.orgList = val
    },
    checkField(val) {
      if (this.dataInfo.info.tableStyleField && this.dataInfo.info.tableStyleField.filedType === 'pivot') {
        this.dealFieldFn(cloneDeep(this.originalList), {
          isAll: true,
          showFieldList: val
        })
      } else {
        for (const ele of this.tableCheckField) {
          this.$set(ele, 'isAppenFeild', true)
          for (const noCheck of val) {
            if (noCheck === ele.name) {
              this.$set(ele, 'isAppenFeild', false)
            }
          }
        }
      }
      this.$refs.oneChild.updateElTable()
    },
    fieldShow() {
      this.$refs.checkField.open({
        selectDatas: this.tableCheckField,
      })
    },
    changeCheckField(val = {}) {
      for (const ele of this.layout) {
        for (const cele of ele.info) {
          if (cele.i === val.id) {
            cele.info.showFieldInfo.fieldShowAll = val.isHide
            break
          }
        }
      }
      this.dealFieldFn(this.originalList, val)
      this.$refs.oneChild.updateElTable()
    },
    dealFieldFn (date, opt = {}) {
      const { isHide, showFieldList = [], isAll = false } = opt
      this.$set(this.dataInfo.info.pivotConfig, 'customField', [])
      if (date && date[0]) {
        let allData = null
        let hideField = []
        if (this.layout) {
          for (const ele of this.layout) {
            const info = ele.info
            for (const cele of info) {
              if (cele.type === 'button' && cele.info.bindingFunction === 'field-show' && cele.info.showFieldInfo && cele.info.showFieldInfo.fieldShowType === 'single' && !cele.info.showFieldInfo.fieldShowAll) {
                hideField.push(...cele.info.showFieldInfo.showFieldList)
              }
            }
          }
        }
        if (isHide) {
          for (const ele of showFieldList) {
            if (hideField.includes(ele)) hideField.splice(hideField.indexOf(ele), 1)
          }
        } else {
          hideField.push(...showFieldList)
        }
        if (isAll) {
          hideField = showFieldList
        }
        for (const key of this.dataInfo.info.pivotConfig.checkFile) {
          const sel = key.filedInfo
          if (sel && sel.previewFormat && sel.previewFormat === 'object') {
            allData = cloneDeep(key)
            this.$set(key, 'isHide', true)
            allData.isHide = false
            let sortConfig = sel.customOptionConfig
            if (sortConfig) {
              sortConfig = sortConfig.split(/\r\n|\n|\r/)
            }
            const value = getResValue(date, allData.title)
            if (value && typeof value === 'object') {
              allData.fatherType = `${allData.title}_${allData.type}`
              let filed = objectToTree(value, {
                customOptions: allData,
                childrenKey: 'list',
                allDatas: this.dataInfo.info.allSyllable,
                hideField,
                sortConfig
              })
              filed = filed.map(item => {
                let ctitle = ''
                let showName = ''
                if (item.filedInfo.isSplitSymbol && item.filedInfo.splitSymbol) {
                  // 开始切割标题
                  const names = item.name.split(item.filedInfo.splitSymbol)
                  ctitle = names.pop()
                  showName = names.join('')
                }
                return {
                  ...item,
                  ctitle,
                  showName,
                  filedInfo: {
                    ...item.filedInfo,
                    name: item.name
                  }
                }
              })

              if (this.dataInfo.info.pivotConfig.customField) {
                // eslint-disable-next-line vue/no-mutating-props
                this.dataInfo.info.pivotConfig.customField.push(...filed)
              } else {
                this.$set(this.dataInfo.info.pivotConfig, 'customField', filed)
              }
            }
          } else {
            let isHide = false
            if (hideField.length !== 0) {
              isHide = hideField.includes(key.name)
            }
            this.$set(key, 'isHide', isHide)
          }
        }
        if (!allData) return date
      }
      return date
    },
    mergeFun (date) {
      const arr = []
      for (let i = 0; i < date.length; i++) {
        let str = {}
        for (const e in date[i]) {
          let flag = false
          const field = this.dataInfo.info.pivotConfig.checkFile.find(val => val.title === e)
          if (field && field.filedInfo && field.filedInfo.previewFormat === 'object') {
            flag = true
          }
          if (flag) {
            const select = this.dataInfo.info.pivotConfig.checkFile.find(val => val.title === e)
            if (select && select.previewFormat) {
              str[e] = JSON.stringify(date[i][e])
            }
            const retStr = this.retsule(date[i][e], e)
            str = Object.assign(str, retStr)
          } else {
            str[e] = date[i][e]
          }
        }
        arr.push(str)
      }
      return arr
    },
    retsule (data, name) {
      let strObj = {}
      // 区分 [] 和 {}
      if (Array.isArray(data)) {
        // 数组[]
        if (data[0] && (data[0].realname || data[0].name)) {
          const ars = data.map(val => { return val.realname || val.name })
          strObj[name] = ars.join(',')
        } else if (data[0] && data[0].response) {
          strObj[name] = data
        } else if (data[0] && data[0].date && data[0].time) {
          // 他是属于预约时间段的，不做任何转化
          strObj[name] = data
        } else {
          strObj[name] = data.join(',')
        }
      } else {
        // 对象{}
        if (data.realname) {
          strObj[name] = data.realname
        } else {
          for (const i in data) {
            if (typeof data[i] === 'object') {
              const retStrs = this.retsule(data[i], (name + '.' + i))
              strObj = Object.assign(strObj, retStrs)
            } else {
              strObj[name + '.' + i] = data[i]
            }
          }
        }
      }
      return strObj
    },
    parseDynamicString(str) {
      // 匹配 JSON_OBJECT('key1',$value1,'key2':'value2') 格式
      const regex = /JSON_OBJECT\(([^)]+)\)/;
      const match = str.match(regex);

      if (!match) return null;

      // 解析键值对
      const keyValuePairs = match[1].split(',');
      const result = {};

      for (let i = 0; i < keyValuePairs.length; i += 2) {
        if (i + 1 < keyValuePairs.length) {
          let key = keyValuePairs[i].trim().replace(/'/g, '');
          let value = keyValuePairs[i + 1].trim();

          // 处理 $ 开头的变量和字符串值
          if (value.startsWith('$')) {
            result[key] = value; // 保持 $ 变量形式
          } else {
            result[key] = value.replace(/'/g, ''); // 移除引号
          }
        }
      }

      return result;
    },
    setConditionTitle (str, li) {
      const regex = /\$([\u4e00-\u9fa5a-zA-Z0-9_]+)/g
      str = str.replace(regex, (match) => {
        const name = match.split('$')[1]
        const filed = li.find(item => item.name.replace(' ', '') === name)
        if (filed) {
          return '$' + filed.title
        } else {
          return match
        }
      })
      return str
    },
    async getPivotDataInfo(opt = {}, otherConfig = { }) {
      // 行转列
      let { query = {}, ruledata = {} } = opt
      const { isGetData = false, isExport = false, exportInfo = {} } = otherConfig
      const { pivotConfig = {} } = this.dataInfo.info
      if (!pivotConfig.pool || !pivotConfig.sort) return
      const { sort = [], pool = [] } = pivotConfig
      const param = {
        curpage: this.listInfo.currentPage,
        pagesize: this.listInfo.tablePageSize
      }
      const titleType = {
        '申请人': 'relation-user',
        '提交时间': 'date',
        '最新修改时间': 'date',
        '单号': 'text',
        '状态': 'status',
        '归档状态': 'status',
        '自定义标题': 'text'
      }
      if (isGetData) {
        param.curpage = otherConfig.currentPage !== undefined ? otherConfig.currentPage : this.listInfo.currentPage
        param.pagesize = otherConfig.pagesize !== undefined ? otherConfig.pagesize : this.listInfo.tablePageSize
        if (otherConfig.query) {
          query = { ...query, ...otherConfig.query }
        }
      }
      const where = []
      for (const key in query) {
        const obj = {
          field: key,
          relation: 'in',
          value: query[key]
        }
        where.push(obj)
      }
      const relationType = {
        '包含': 'in',
        '不包含': 'noin',
        '大于': 'gt',
        '大于等于': 'gte',
        '小于': 'lt',
        '小于等于': 'lte',
        '等于': 'eq',
        '不等于': 'neq',
        '为空': 'is null',
        '非空值': 'noVacant',
        '空值': 'vacant',
        '包含当前用户': 'curuser',
        '等于任一成员': 'qtUser',
        '不等于任一成员': 'nQtUser',
        '当天': 'thatDay',
        '昨天': 'yesterday',
        '本周': 'thisWeek',
        '上周': 'lastWeek',
        '本月': 'thisMonth',
        '上月': 'lastMonth',
        '固定值': 'fixed',
      }
      for (const key in ruledata.fixquery) {
        if (key !== 'ov') {
          const obj = {
            field: key,
            relation: relationType[ruledata.fixquery[key].op],
            value: ruledata.fixquery[key].value
          }
          where.push(obj)
        }
      }

      if (isExport && exportInfo.radio === 1) {
        where.push({
          field: 'approving_id',
          relation: 'in',
          value: this.multipleSelection.map(item=>item['approving_id'])
        })
      }

      if (isExport && exportInfo.radio === 3) {
        // 按时间导出
        where.push({
          field: '提交时间',
          relation: 'between',
          value: exportInfo.time
        })
      }

      if (isExport && exportInfo.radio === 4) {
        where.push({
          field: 'approving_id',
          relation: 'in',
          value: this.listInfo.tableData.map(item=>item.approving_id)
        })
      }

      let four = {}

      const fixorder = ruledata.fixorder

      if (fixorder && fixorder.length > 0) {
        const orderby = []
        for (const ele of fixorder) {
          const [title] = ele.feild.split('_')
          const obj = {
            key: ele.key,
            title,
            feild: ele.feild,
            value: ele.value,
            setting: ele.feild
          }
          orderby.push(obj)
        }
        four = {
          id: getRandom(10000, 99999),
          filter: orderby,
          type: 'orders',
          dataconfig: {
            orderby
          },
          parentid: [],
        }
      }
      const allSyllable = this.dataInfo.info.allSyllable.filter(f=>f.title !== '解析数据')
      const fields = allSyllable.map(item=>{
        if (item.title === '最新修改时间') {
          return '修改时间_date'
        } else {
          return `${item.title}_${item.type || titleType[item.title]}`
        }
      })
      const select = allSyllable.map(item => item.title === '最新修改时间' ? '修改时间' : item.title)
      const one = {
        id: getRandom(10000, 99999),
        dataconfig: {
          rel: 'and',
          fields,
          select,
          formid: this.approval.approvalId || this.approval.id
        },
        type: 'source',
        parentid: [],
        approvalId: this.approval.approvalId || this.approval.id
      }
      if (where.length !== 0) {
        one.dataconfig.where = where
      }
      const fieldalias = []
      const newName = []
      for (const ele of sort) {
        const obj = {
          name: `${ele.title}`,
          alias: `${ele.title}`,
          formula: ''
        }
        const obj2 = {
          name: `${ele.title}`,
          alias: `${ele.name}`,
          formula: ''
        }
        newName.push(obj2)
        fieldalias.push(obj)
      }
      for (const ele of pool) {
        let obj = {}
        let obj2 = {}
        if (ele.isFormula) {
          const li = ele.condition.match(/([A-Z]+)\((.*)\)/)
          let name = li[li.length - 1].replace()
          name = this.setConditionTitle(name, this.dataInfo.info.allSyllable)
          const value = this.parseDynamicString(name)
          const listTodoConfig = this.dataInfo.info.listTodoConfig
          if (listTodoConfig && listTodoConfig.length > 0) {
            const listTodo = listTodoConfig.find(item => item.title === ele.title)
            if(listTodo) {
              const info = listTodo.info
              for (const field in value) {
                const title = value[field].split('$')[1]
                const fi = this.appProperty.find(item=>item.title === title)
                if (fi) {
                  const obj = {
                    ...fi,
                    otherName: field,
                    info
                  }
                  this.$set(this.listTodoField, field, obj)
                }
              }
            }
          }
          const formula = ele.condition.split('(')[0]
          obj = {
            name: name,
            alias: ele.title,
            formula
          }
          obj2 = {
            name: ele.title,
            alias: ele.title,
            formula: ''
          }
        } else {
          obj = {
            name: ele.title,
            alias: `${ele.title}`,
            formula: 'min'
          }
          obj2 = {
            name: ele.title,
            alias: ele.name,
            formula: ''
          }
        }

        newName.push(obj2)
        fieldalias.push(obj)
      }
      // 固定加上这个 才会有数据Id返回
      fieldalias.push({
        name: 'approving_id',
        alias: 'approving_id',
        formula: 'min'
      })
      const second = {
        id: getRandom(10000, 99999),
        parentid: [one.id],
        type: 'pool',
        dataconfig: {
          groupby: sort.map(item => item.title),
          fieldalias
        },
        sort: sort,
        pool: pool
      }
      const config = [one, second]
      if (Object.keys(four).length !== 0) {
        const three = {
          id: getRandom(10000, 99999),
          parentid: [second.id],
          type: 'fieldSys',
          datasSys: second.dataconfig.fieldalias.map(item => ({ ...item, formula: '', name: item.alias })),
          dataconfig: {
            fieldalias: second.dataconfig.fieldalias.map(item => ({ ...item, formula: '', name: item.alias }))
          }
        }
        four.parentid = [three.id]
        config.push(three, four)
      }
      if (isExport) {
        const checkFile = this.dataInfo.info.pivotConfig.checkFile
        const objControl = checkFile.find(item=>item.customType === 'summary' && item.condition.includes('JSON_OBJECTAGG'))
        const fields = { field: objControl.name }
        const appname = this.approval.appname
        const center = exportInfo.center
        const filter = ['approving_id']
        for (const ele of checkFile) {
          const idx = center.findIndex(f=> f.name === ele.name)
          if (idx === -1) {
            filter.push(ele.name)
          }
        }
        const output = center.map(item => {
          const obj = {
            field: item.name,
          }
          if (item.id) {
            obj.id = true
          }
          return obj
        })
        if (this.dataInfo.info.pivotConfig && Array.isArray(this.dataInfo.info.pivotConfig.showLevel) && this.dataInfo.info.pivotConfig.showLevel.length === 1) {
          const name = objControl.conditionList[objControl.conditionList.length - 1].split(',')[0]
          fields.key = extractChinese(name)
        }
        const exported = {
          fields,
          appname,
          filter,
          output
        }
        param.exported = JSON.stringify(exported)
        const five = {
          id: getRandom(10000, 99999),
          parentid: [config[config.length - 1].id],
          type: 'fieldSys',
          dataconfig: {
            fieldalias: newName
          },
          datasSys: [...pool, ...sort],
        }
        config.push(five)
      }
      param.config = config
      param.nodeId = config[config.length - 1].id
      if (isExport && exportInfo.radio === 5) {
        param.curpage = 0
        param.pagesize = 0
      }
      const res = await getapprovalreportpreview(param)
      if (res.code === 0) {
        if (isExport) {
          if (!Array.isArray(res.data)) {
            await filePreview({ url: `/${res.data}` }, true)
            this.progressStatus(true)
          } else {
            this.progressStatus('')
          }
        } else {
          let data = res.data.map(item=>{
            return {
              approvingId: item.approving_id,
              ...item
            }
          })
          this.originalList = data
          data = this.dealFieldFn(data)
          data = this.mergeFun(data)
          if (!otherConfig.isGetData) {
            if (res.data.length === res.total) this.isNoList = true
            this.listInfo.currentPage = res.curpage
            this.listInfo.tableTotal = res.total
            this.listInfo.tableData = data
            this.listInfo.tablePageSize = res.pagesize
          } else {
            this[otherConfig.saveKey] = data
            this.toImportData()
          }
        }
      }
    },
    screenCloseLoading (id) {
      if (this.loadingIds.indexOf(id) === -1) {
        this.loadingIds.push(id)
      }
      if (this.loadingIds.length === this.screenNum) {
        this.loading = false
      }
    },
    // 获取筛选组件之间的关联
    getScreenRelation () {
      const relation = {}
      const screenList = []
      this.layout.forEach(item => {
        if (Array.isArray(item.info)) {
          item.info.forEach(iten => {
            if (iten.type === 'screen') {
              screenList.push(iten)
            }
          })
        }
      })
      screenList.forEach(item => {
        if (item.screenLevel && item.screenLevel.levelList) {
          item.screenLevel.levelList.forEach(levelItem => {
            if (levelItem.rulerData.fixquery && Array.isArray(levelItem.rulerData.fixquery.linked)) {
              levelItem.rulerData.fixquery.linked.forEach(linkItem => {
                if (linkItem.screenValue) {
                  linkItem.screenValue.forEach(screenValueItem => {
                    if (relation[screenValueItem[0]]) {
                      relation[screenValueItem[0]].push(item)
                    } else {
                      relation[screenValueItem[0]] = [item]
                    }
                  })
                }
              })
            }
          })
        }
      })
      this.screenRelation = relation
    },
    setRefreshTime() {
      const isTimedRefresh = this.dataInfo.info.tableStyleField.isTimedRefresh
      if (isTimedRefresh && !this.refreshTimer) {
        const oneMinute = 60 * 1000
        const refreshTime = this.dataInfo.info.tableStyleField.refreshTime || 1
        this.refreshTimer = setInterval(async () => {
          await this.handleListInfo(this.dataInfo.pageId, this.isSearchStatus ? this.searchText : '', this.querys)
        }, refreshTime * oneMinute)
      }
    },
    cardDataDel (index) {
      if (index >= 0 && this.$refs.cardRef) {
        this.$refs.cardRef.delTableData(index)
      }
    },
    async replaceSelectField(approvalId) {
      const params = {
        approvalId
      }
      if (this.spaceid) {
        params.spaceid = this.spaceid
      } else if (this.upaceid) {
        params.upaceid = this.upaceid
      }
      const { data, code } = await getapprovalcontent(params)
      if (code === 0) {
        const li = this.dataInfo.info.checkSyllable.map(item => {
          const idx = data.findIndex(f => f.title === item.title)
          if (idx !== -1) {
            return {
              ...item,
              ...data[idx]
            }
          } else {
            return item
          }
        })
        // eslint-disable-next-line vue/no-mutating-props
        this.dataInfo.info.checkSyllable = li
      }
    },
    dealOrginClose() {
      const isOrgOpen = !this.isOrgOpen
      let treeRef = this.$refs.orgTree
      treeExpandOrFold(treeRef, isOrgOpen)
      this.isOrgOpen = !this.isOrgOpen
    },
    getScreenRectInfo (comps, type = 'customW') {
      return getScreenRectInfo(comps, type)
    },
    isAdaption (val) {
      return isAdaption(val)
    },
    isReadyWidget(title, list = []) {
      // 判断是否为预约控件
      const flag = cloneDeep(list).find(item => item.title === title)
      if (flag) return false
      const childrenList = list.filter(item=> Boolean(item.list))
      if (childrenList.length === 0) return false
      const readyWidget = childrenList.find(c=>c.type === 'ready-widget')
      if (readyWidget) {
        return `${readyWidget.title}_${readyWidget.type}[0]/${title}`
      }
    },
    async goListSearch(filed, info) {
      // 处理 数据
      let { title, type } = filed
      const { type: infoType, value } = info
      let query = {}
      const fixorder = []
      let titleKey = ''
      const orderValue = {
        positiveSequence: 'asc',
        reverseOrder: 'desc'
      }
      if (infoType === 'order') {
        const flag = this.isReadyWidget(title, JSON.parse(this.approval.property))
        if (flag) {
          title = flag
        }
        const obj = {}
        obj.key = orderValue[value] 
        obj.value = orderValue[value] 
        obj.feild = `${title}_${type}`
        fixorder.push(obj)
      } else {
        const flag = this.isReadyWidget(title, JSON.parse(this.approval.property))
        if (flag) {
          title = flag
        }
        let key = `${title}_${type}`
        if (title === '申请人') {
          type = 'relation-user'
          key = `${title}_${title}`
        }
        if ((['organization', 'roule', 'relation-user'].includes(type))) {
          // 角色 组织 联系人
          let list = []
          const apiRouteObj = {
            'relation-user': getopenuserlist,
            'roule': getopenrolelist,
            'organization': getopenorganizationlist,
            '申请人': getopenorganizationlist,
          }
          const param = {
            curpage: 0,
            pagesize: 0,
          }
          if (type === 'roule') {
            param.role = 1
            param.name = value
          } else if (type === 'organization') {
            param.name = value
          } else if (type === 'relation-user') {
            param.names = value
          }
          if (this.spaceid) {
            param.spaceid = this.spaceid
          }
          if (this.upaceid) {
            param.upaceid = this.upaceid
          }
          const api = apiRouteObj[type]
          if (value) {
            const res = await api(param)
            if (res.code === 0) {
              list = res.data.map(item=>{
                if (type === 'relation-user' || type === '申请人') {
                  return { userId: item.userId, name: item.realname }
                } else if (type === 'ruole') {
                  return { roleId: item.roleId, name: item.name }
                } else if (type === 'organization') {
                  return { organizationId: item.organizationId, name: item.name }
                }
              })
              if (list.length === 0) {
                return
              }
            }
          }
          query[key] = list
        } else if (['text', 'textarea', 'radio', 'checkbox', 'number'].includes(type)) {
          // 其他控件
          if(value) query[key] = [value]
        } else if (['date', 'timeof'].includes(type)) {
          query[key] = value
        } else if (title === '自定义标题') {
          titleKey = value
        }
      }
      this.titleQeury = query
      this.titleOrder = fixorder
      this.handleListInfo(this.dataInfo.pageId, titleKey, this.querys)
    },
    dealShowName(data){
      return getOrgShowName(data)
    },
    getFlowShowText () {
      let str = '流程'
      if (this.baseset) {
        const baseset = typeof this.baseset === 'string' ? JSON.parse(this.baseset) : this.baseset
        if (baseset.flowshow && baseset.flowshow.type) {
          if (baseset.flowshow.viewText) {
            str = baseset.flowshow.viewText
          } else {
            str = baseset.flowshow.type === 'dialogue' ? '交流' : '流程'
          }
        }
      }
      return str
    },
    upBaseset (val) {
      this.baseSet = val
    },
    editUserInfo(info, row) {
      if (!row) {
        row = this.multipleSelection[0]
      }
      this.goEditUserInfo(row, info)
    },
    getInitList() {
      const initConfig = this.dataInfo.info.initConfig
      if (!initConfig || initConfig.list.length === 0) return true
      const list = initConfig.list || []
      let flag = false
      // const isInclude = list.includes(id)
      // if(!isInclude) return false
      for (const id in this.screenSearch) {
        const item = list.find(c => c === id)
        if (!item) continue
        else flag = true
      }
      if (!flag) return true
      let count = 0
      for (const ele of this.initList) {
        const item = list.find(c=> c === ele)
        if (item) {
          count++
        }
      }
      return count === list.length
    },
    async appPrint(row = {}){
      const approvingId = row.approvingId
      const userapprovingId = row.userApprovingId
      // 数据
      const param1 = {
        curpage: 0,
        pagesize: 0,
        userapprovingId,
        approvalId: this.dataInfo.info.apply.id || this.dataInfo.info.apply.approvalId,
      }
      // 流程
      const param2 = {
        curpage: 0,
        pagesize: 0,
        approvingId,
        approvalId: this.dataInfo.info.apply.id || this.dataInfo.info.apply.approvalId,
      }
      try {
        const data1 = await openapiGetuserapprovinglist(param1)
        const data2 = await openapiGetuserapprovinglist(param2)
        const btnList = await this.getButtonList()
        const AuditList = data2.data
        const opt = {
          btnList,
          AuditList,
          data: data1.data[0]
        }
        this.goPrint(opt)
      } catch (error) {
        console.log(error);
      }
    },
    async getButtonList () {
      const res = axiosBase({approvalId: this.dataInfo.info.apply.id || this.dataInfo.info.apply.approvalId}, "/api/getapprovalselection")
      if (res.code === 0) {
        for (let i in res.data) {
          res.data[i] = res.data[i].split("|");
        }
        return res.data;
      }
    },
    goPrint(opt = {}) {
      const { AuditList, btnList, data } = opt
      var auditListData = AuditList;
      var stateObj = {};
      var processData = [];
      var applyUser = ""; //申请人
      const approvalProcess4 = (val, item)=> {
        const idx = val.approsel
        const approver = val.approving.approver
        const step = val.step
        const cur = approver[step] || {}
        if (idx === -1) {
          return "转办";
        }
        if (!item) return cur.customStatus
        if (idx !== -1) {
          return item[idx][2];
        }
      }
      const approvalProcess1 =  (val, item)=> {
        const idx = val.approsel
        // 测试说这里值和 4  的反了，现在调换一下
        const approver = val.approving.approver
        const step = val.step
        const cur = approver[step] || {}
        if (!item) {
          return "转 办";
        } else {
          if (cur.customStatus) {
            return cur.customStatus
          } else {
            return item[idx] && item[idx].length > 3 ? item[idx][3] : "审批中";
          }
        }
      }
      const approvalProcess2 = (val, item)=> {
        const idx = val.approsel
        // 测试说这里值和 4  的反了，现在调换一下
        const approver = val.approving.approver
        const step = val.step
        const cur = approver[step] || {}
        if (cur.customText) {
          return cur.customText.agree.showText
        }
        if (!item) return "同 意";
        if (idx === -1) {
          return item[item.length - 1][0]
        }else {
          return item[idx][0];
        }
      }
      const approvalProcess3 = (val, item)=> {
        const idx = val.approsel
        // 测试说这里值和 4  的反了，现在调换一下
        const approver = val.approving.approver
        const step = val.step
        const cur = approver[step] || {}
        if (cur.customText) {
          return cur.customText.refused.showText
        }
        if (!item) return "拒绝";
        if (idx === -1) {
          return item[item.length - 1][1]
        } else {
          return item[idx][1];
        }
      }
      let userMsg = localStorage.getItem('userMsg')
      if (userMsg) {
        userMsg = JSON.parse(userMsg)
      }
      const isTime = this.approval.istime || 0
      const { othersObj, ruleList, formData } = this.templateFun(this.approval, data, AuditList)
      auditListData.forEach((elEm) => {
        var stateData = {};
        //获取数据
        var typeIs = elEm["type"];
        var statusIs = elEm["status"];
        var wayIs = elEm["way"];
        var approselIs = elEm["approsel"]; //处理流程环节-名称
        var signIs = elEm["sign"]; //处理流程环节-评论
        //数据构造。判断
        if (wayIs && wayIs == "4") {
          approselIs = approvalProcess4(elEm, btnList);
          if (elEm.approuser && elEm.approuser.length > 0)
            stateData.userText = elEm.approuser
              .map(vals => {
                return vals.approname;
              })
              .join(",");
        } else if (wayIs && wayIs == "3") {
          approselIs = this.launchdataPl;
        } else {
          if (typeIs == "0" && statusIs != "3") {
            //发起环节获取申请人
            approselIs = '发起'
            applyUser = elEm.user?elEm.user.realname:''; //申请人
          } else if (typeIs == "0" && statusIs == "3") {
            // 这边写死 不知道为什么 在详情页那边也写死了
            approselIs = '撤回'
          } else if (statusIs == "1" && typeIs == "1" && wayIs != "3") {
            approselIs = approvalProcess2(elEm, btnList);
          } else if (
            (statusIs == "0" && typeIs == "1" && wayIs != "3") ||
            statusIs == "4"
          ) {
            approselIs = approvalProcess1(elEm, btnList);
          } else if (statusIs == "2" && typeIs == "1" && wayIs != "3") {
            approselIs = approvalProcess3(elEm, btnList);
          }
        }
        stateData.stateUser = elEm.user?elEm.user.realname:''; //申请人
        if (isTime === 0)
          stateData.stateTime = formatDate(
            new Date(elEm.ctime),
            "yyyy-MM-dd hh:mm"
          ); // 处理时间
        stateData.stateName = approselIs; //处理流程
        if (elEm.comment) {
          stateData.stateMain = elEm.comment;
        } else if (elEm.note) {
          stateData.stateMain = elEm.note;
        } else {
          stateData.stateMain = "";
        }
        // 添加签名
        if (signIs) {
          const accesstoken = JSON.parse(localStorage.getItem('user')).accesstoken
          stateData.stateSignIs = `${this.$imgurl}${signIs}?accesstoken=${accesstoken}`
        }

        processData.push(stateData);
      });
      //获取用户信息。学校名称/表头数据
      var loginDataObj = {};
      var affairName = data.appname; //事务名称
      var applyDate = data.approving.ctime; //申请日期
      //用户信息。 login.vue 缓存
      var schoolName = "";
      let userMsg_external = localStorage.getItem("userMsg_external"); //- 新增外链模式下面的userMsg
      if (userMsg_external) {
        userMsg_external = JSON.parse(userMsg_external);
        schoolName = userMsg_external.schoolMsg.name;
      } else {
        schoolName = userMsg.schoolMsg && userMsg.schoolMsg.name;
      }
      loginDataObj.affairName = affairName;
      loginDataObj.applyDate = applyDate;
      loginDataObj.schoolName = schoolName; //学校名
      loginDataObj.applyUser = applyUser;
      //数据结果
      stateObj.processData = processData;
      stateObj.loginDataObj = loginDataObj;
      //替换数据权限
      const AuditDataOvb = JSON.parse(JSON.stringify(data));
      let ruleListArr = JSON.parse(JSON.stringify(ruleList));
      const formdata = othersRed(ruleList, copyObj(formData), othersObj);
      const valKey = oaAuditPrintingFunc(ruleListArr, formdata, 1);
      AuditDataOvb.approving.formdata = valKey;
      // 时间值手动替换过去s
      AuditDataOvb.istime = isTime;
      this.$refs.oaAuditPrintingChild.oaAuditPrintingChildFun(AuditDataOvb, stateObj, this.defaultPrintShowKey);
    },
    templateFun (e, date, AuditList) {
      if (e.property) {
        console.log("解析模板",e);
        let ruleList = JSON.parse(e.property);
        let formdata = momVal(JSON.parse(e.property))
        formdata = assignFormdata(formdata, JSON.parse(date.approving.formdata));
        let OthersFormdata = setOthersFormdata(ruleList, formdata);
        formdata = OthersFormdata.formdata;
        const resRuleList = OthersFormdata.template;
        const resOthersObj = OthersFormdata.othersObj;
        
        // 明细数据兼容小程序bug
        for(let key in formdata) {
          if (key.search('details')!== -1) {
            formdata[key].forEach(item=>{
              for(let _key in item) {
                if (_key.search('relation-user')!== -1 || _key.search('radio')!== -1) {
                  if (item[_key]) {
                    item[_key] = item[_key].value ? item[_key].value : item[_key]
                  } 
                  try {
                    if (_key.search('relation-user')!== -1) {
                      item[_key] = typeof item[_key] == 'string' ? JSON.parse(item[_key]) : item[_key]
                    }
                  }catch(e){
                    console.log('解析错误', e)
                  }
                } 
              }
            })
          }
        }
        const defaultKey = {}
        if (Array.isArray(AuditList) && AuditList[0]) {
          const defaultKeyList = ['申请人_relation-user', '单号_text', '状态_status', '提交时间_date', '归档状态_status']
          defaultKeyList.forEach(item => {
            defaultKey[item] = DealPrintData.handleDefaultKey(item, AuditList[0])
          })
        }
        const formData = {...formdata, ...defaultKey}
        return {
          formData,
          ruleList: resRuleList,
          othersObj: resOthersObj,
        }
      }
      return {}
    },
    setDefaultFiled() {
      if (this.dataInfo.info.tableStyleField === undefined) {
        const tableStyleField = {
          isSerialNumber: false,
          isAppenTitle: false,
          isInitTable: true,
          isTodoList: false,
          idxWidth: '50',
          textLine: 1,
          customLine: 1,
          saveArea: 'all-all',
          customArea: 1280,
          pageNum: '50',
          customPageNum: 1,
          listLineHeight: '36px',
          // 表格宽度
          tableWidth: 'fixed', // fixed 固定宽度模式  scroll 滚动条模式
          loadingMethod: 'pageCutting' // scroll 滚动加载 pageCutting 切页加载 hidden 隐藏
        }
        // eslint-disable-next-line vue/no-mutating-props
        this.dataInfo.info.tableStyleField = tableStyleField
      }
      if (this.dataInfo.info.listStyleConfig === undefined) {
        const listStyleConfig = {
          bgTransparent: true,
          boxShadow: true,
          minMargin: 10,
          titleStyle: {
            content: '',
            style: {
              fontSize: '18px',
              fontFamily: '微软雅黑',
              fontWeight: 'normal',
              fontStyle: 'normal',
              textDecoration: 'none',
              color: '#333',
              textAlign: 'left'
            }
          },
          bgfllStyle: {
            bgstyle: 'color',
            color: 'rgba(244,245,245,1)',
            picture: {
              layout: 'default',
              pictype: 'upload',
              url: ''
            }
          },
          toolfllStyle: {
            bgstyle: 'color',
            color: 'rgba(255,255,255,1)',
            picture: {
              layout: 'default',
              pictype: 'upload',
              url: ''
            }
          },
          tablefllStyle: {
            bgstyle: 'color',
            color: 'rgba(255,255,255,1)',
            picture: {
              layout: 'default',
              pictype: 'upload',
              url: ''
            }
          },
          titleConfig: {
            color: '#333',
            fontFamily: '微软雅黑',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '600',
            justifyContent: 'flex-start',
            textAlign: 'left',
            textDecoration: 'none'
          },
          valueConfig: {
            color: '#333',
            fontFamily: '微软雅黑',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 'normal',
            justifyContent: 'flex-start',
            textAlign: 'left',
            textDecoration: 'none'
          }
        }
        // eslint-disable-next-line vue/no-mutating-props
        this.dataInfo.info.listStyleConfig = listStyleConfig
      }
      if (this.dataInfo.info.initConfig === undefined) {
        const initConfig = {
          list: [],
          img: 'https://bigdata.topeti.com/PCRepository/middleground/no-data.svg',
          tips: '请选择数据'
        }
        // eslint-disable-next-line vue/no-mutating-props
        this.dataInfo.info.initConfig = initConfig
      }
    },
    async getApperInfo(approvalId) {
      if (!approvalId) return
      const __par = { approvalId }
      if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        __par.upaceid = upaceId
      }
      const { code, data } = await openapiGetapproval(__par)
      
      if (code === 0) {
        if (data && data.pageset) {
          const pageSet = await getConfigFromUrl(this.$url + JSON.parse(data.pageset).url)
          if (pageSet && pageSet[3]) {
            const { defaultPrintShowKey } = pageSet[3]
            // 是否有默认报表的打印字段配置 
            if (defaultPrintShowKey !== undefined) {
              this.defaultPrintShowKey = defaultPrintShowKey
            }
          }
        }
        // this.dataInfo.info.apply = data
        const property = JSON.parse(data.property)
        const details = property.find(item => item.type === 'details')
        if (details) {
          const li = cloneDeep(this.dataInfo.info.checkSyllable)
          for (const key in li) {
            const ele = this.dataInfo.info.checkSyllable[key]
            if (ele.type === 'details' && ele.filedInfo && ele.filedInfo.detailed && ele.filedInfo.detailed.displayEffect === 'horizontal') {
              const details = property.find(item => item.title === ele.title)
              if (details) {
                ele.list = details.list
                // this.dataInfo.info.checkSyllable.splice(key + 1, 0, ...details.list)
              }
            }
          }
        }
        this.appProperty = property
        if (this.customDeskInfo && this.customDeskInfo.customDeskId) {
          this.customParams = this.$store.state.doorCustomDataObj[this.customDeskId] || []
        } else if (data.variableconfig) {
          this.customParams = JSON.parse(data.variableconfig)
        }
        // 传入的参数
        if (this.customDeskInfo && this.customDeskInfo.paramsList) {
          const flag = isObject(this.customDeskInfo.paramsList)
          if (flag) {
            this.paramsList = this.customDeskInfo.paramsList
          } else {
            this.paramsList = JSON.parse(this.customDeskInfo.paramsList)
          }
          const resList = await this.setParams({ customData: cloneDeep(this.customParams) }, null, true)
          this.customParams = resList || this.customParams
        }
        let list = this.dataInfo.info.listTodoConfig || []
        list = list.map(item => {
          const control = property.find(c=>c.title === item.title)
          if (control) {
            return {
              ...item,
              ...control,
              info: item.info
            }
          } else {
            return item
          }
        })
        // eslint-disable-next-line vue/no-mutating-props
        this.dataInfo.info.listTodoConfig = list
        // eslint-disable-next-line vue/no-mutating-props
        this.dataInfo.info.apply = { ...data, id: data.approvalId }
        this.approval = data
        let formdata = momVal(property)
        const obj = {
          property,
          formdata
        }
        this.addConfig = obj
      }
    },
    getSplitTodoScreen(type = 'screen') {
      const typeObj = {
        screen: 'screenAppen',
        list: 'listAppen',
      }
      if (this.splitInfoComp.direction === 'level') {
        if (this.splitScreenInfo.config.splitInfo && this.splitScreenInfo.config.splitInfo[typeObj[type]] === 'open') {
          return `level-${type}-todo`
        } else {
          return `level-${type}-close-todo`
        }
      } else if (this.splitInfoComp.direction === 'vertical') {
        if (this.splitScreenInfo.config.splitInfo && this.splitScreenInfo.config.splitInfo[typeObj[type]] === 'open') {
          return `vertical-${type}-todo`
        } else {
          return `vertical-${type}-close-todo`
        }
      }
    },
    closeSplitScreen(type){
      const { config = {} } = this.splitScreenInfo
      if (type === 'screenAppen') {
        if (config.splitInfo.screenAppen === 'open') {
          this.splitScreenInfo.config.splitInfo.screenAppen = 'close'
          if (this.splitPanelSlot === 'paneF') {
            this.defaultPrecent = 0
          } else {
            this.defaultPrecent = 100
          }
        } else {
          this.splitScreenInfo.config.splitInfo.screenAppen = 'open'
          this.defaultPrecent = this.splitScreenInfo.defaultPrecent
        }
      }
      if (type === 'listAppen') {
        if (config.splitInfo.listAppen === 'open') {
          this.splitScreenInfo.config.splitInfo.listAppen = 'close'
          if (this.splitPanelSlot === 'paneF') {
            this.defaultPrecent = 100
          } else {
            this.defaultPrecent = 0
          }
        } else {
          this.splitScreenInfo.config.splitInfo.listAppen = 'open'
          this.defaultPrecent = this.splitScreenInfo.defaultPrecent
        }
      }
    },
    clickRow(row) {
      this.detailInfo = cloneDeep(row)
      if (this.$refs.splitScreen) {
        this.$refs.splitScreen.openDetail(row)
      }
    },
    getToolBgInfo(item) {
      const listStyleConfig = this.dataInfo.info.listStyleConfig
      if (!listStyleConfig) return
      let toolfllStyle = listStyleConfig.toolfllStyle
      if (item.bgInfo) {
        toolfllStyle = item.bgInfo
      }
      return getToolBgInfo(toolfllStyle)
    },
    async openAppDialog(val){
      // 数据导入的特殊处理
      if (val.dialogUrl.search('TMbulkImport') !== -1) {
        if (val.dataFrom) {
          if (val.AiDropData) {
            this.importLinked(val.info.info, null, val.chooseField || [], val.AiDropData)
          } else {
            await this.getImportData(val.dialogUrl)
          }
        } else {
          const queryStr = this.getQueryStr(val.dialogUrl)
          if (queryStr.isUpdateById === 'true') {
            await this.getImportAllData(queryStr)
          }
        }
      }
      this.$set(this, 'dialogInfo', val)
    },
    getQueryStr (str) {
      let queryStr
      try {
        queryStr = decodeURIComponent(str).split('?')[1]
      } catch (error) {
        queryStr = str.split('?')[1]
      }
      try {
        queryStr = queryStr.replace(/&gt;/g, '>').replace(/&lt;/g, '<');
        queryStr = qs.parse(queryStr, {
          decoder: (str)=> decodeURIComponent(str.replace(/\+/g, '%2B'))
        })
      } catch (error) {
        queryStr = queryStr.replace(/&gt;/g, '>').replace(/&lt;/g, '<');
        queryStr = qs.parse(queryStr)
      }
      return queryStr
    },
    async getImportData(obj) {
      // 获取当前页面过滤条件的前1000条数据
      const otherConfig = {
        isGetData: true,
        saveKey: 'importData',
        currentPage: 1,
        pagesize: 1000
      }
      this.importConfig = obj
      if (obj.dataFrom === 3 && obj.time) {
        // 获取指定时间内前1000条数据
        otherConfig.query = { date_timeof: obj.time }
      }
      await this.handleListInfo(this.dataInfo.pageId, this.isSearchStatus ? this.searchText : '', this.querys, '0', {}, otherConfig)
    },
    async getImportAllData (obj) {
      // 获取当前页面过滤条件的前1000条数据
      const otherConfig = {
        isGetData: true,
        saveKey: 'importData',
        currentPage: 0,
        pagesize: 0
      }
      this.importConfig = obj
      if (this.listInfo.tableData.length === this.listInfo.tableTotal) {
        this.importData = this.listInfo.tableData
        this.toImportData()
      } else {
        await this.handleListInfo(this.dataInfo.pageId, this.isSearchStatus ? this.searchText : '', this.querys, '0', {}, otherConfig)
      }
    },
    toImportData () {
      if (this.importConfig.isUpdateById === 'true') {
        localStorage.setItem('importAllData', JSON.stringify(this.importData))
      } else if (this.importConfig && this.importConfig.dataFrom !== 1) {
        this.importLinked(this.importConfig.info.info, this.importData, this.importConfig.chooseField || [])
      }
    },
    changeActiveId (id, item) {
      const prevId = item.activeId
      const list = item[prevId]
      for (const info of list) {
        if (info.type === 'screen') {
          let type = info.screenType
          let title = info.title
          if (type === 'timeof') {
            type = 'date'
          }
          // 由于 申请人和申请时间 要走fixquery
          const typeName = {
            appuser: '申请人',
            date: '提交时间'
          }
          const submitName = `${typeName[title] || title}_${type}`
          delete this.screenSearch[info.i]
          delete this.screenQuery[submitName]
          delete this.querys[submitName]
          delete this.screenFixQuery[submitName]
          if (this.ruledata && this.ruledata.fixquery) {
            delete this.ruledata.fixquery[submitName]
          }
        }
      }
      item.activeId = id
    },
    leftLayout (item) {
      const value = this.getCorrectInfo(item)
      return value.filter(c => c.isLeft === true || c.isLeft === undefined)
    },
    rightLayout (item) {
      const value = this.getCorrectInfo(item)
      return value.filter(c => c.isLeft === false)
    },
    getCorrectInfo (item) {
      const activeId = item.activeId

      let list = []
      if (!activeId) {
        list = item.info
      } else {
        list = item[activeId] || []
      }
      const customData = this.$store.state.doorCustomDataObj[this.customDeskId] || this.$store.state.doorCustomData
      list = list.filter(item => {
        let isView = true
        if (item.info && item.info.conditionAppen) {
          isView = isConditionAppen(item.info.conditionAppen, {}, true, customData)
        }
        return isView
      })
      return list
    },
    getKey(item) {
      const id = item.activeId
      if (id) {
        return id
      } else {
        return 'info'
      }
    },
    typePageNum(val) {
      const obj = {
        1: 'fillReportNum',
        2: 'agencyNum',
        3: 'toBeRead',
      }
      const num = this[obj[val]]
      if (num === 0) {
        return false
      } else {
        return num
      }
    },
    async getAgencyNum(id) {
      // 获取应用代办点数
      if (!id) return
      const param = {
        number: 2,
        approvalId: id
      } 
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        param.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        param.upaceid = upaceId
      }
      const {data, code} = await openapiGetapprovalnum(param)
      if (code === 0) {
        const obj = {
          '待我处理': 'agencyNum',
          '待阅': 'toBeRead',
          '我填报的': 'fillReportNum'
        }
        Object.keys(data).forEach(c => {
          this[obj[c]] = data[c]
        })
      }
    },
    openDictionary(info) {
      const val = cloneDeep(info)
      if (val.schoolId) delete val.schoolId;
      let str = typeof val.options === 'string' ? JSON.parse(val.options) : val.options
      str = str.join(',')
      val.options = str.replace(/,/g, '\n')
      this.$refs.upOption.viewDialog({ title: '编辑选项' }, val);
    },
    progressStatus(status) {
      const flag = typeof status === 'boolean'
      this.isProgress = true
      if (flag) {
        this.$message.success('导出成功')
      } else {
        this.$message.error('导出失败')
      }
    },
    async isValidateapprovaltimeswitch(type) {
      if (!this.dataInfo && !this.dataInfo.info && (!this.dataInfo.info.apply.id || !this.dataInfo.info.apply.approvalId) ) return
      const payload = { type, approvalId: this.dataInfo.info.apply.id || this.dataInfo.info.apply.approvalId }
      const upaceId = this.isUpace ? (this.$route.query.upaceid || localStorage.getItem('upaceid')) : undefined
      const data = await isValidateapprovaltimeswitch(payload, upaceId)
      if (data) {
        this.isPower = false
        this.validateType = 1
        return true
      }
    },
    upIsAi (val) {
      this.isAi = val
    },
    upIsPcwidth (val) {
      this.pdwidth = val
    },
    upIsPcHeight(val){
      this.pdheight = val
    },
    tableDetail(row, dataInfo, type = 'detail') {
      if (this.$refs.oneChild) {
        this.$refs.oneChild.tableDetail(row, true, dataInfo, type)
      }
    },
    dialogClose() {
      this.popUpsObj = {
        popUps: {},
        url:''
      }
    },
    customScene(val) {
      const { url, query, open, popUps } = val
      const obj = {
        2: 'dialog',
        3: 'new',
        4: 'old',
        5: 'rightdia'
      }
      this.dialogInfo = {
        isVisible: true,
        dialogName: query.name,
        dialogWidth: popUps.w + 'px',
        dialogHeight: popUps.h + 'px',
        openType: obj[open],
        dialogUrl: url,
        customSize: popUps.customSize,
        diaSize: popUps.diaSize,
      }
    },
    clickTable(row) {
      this.dealInside(row,this.dataInfo.info.clickEffect.clickInsideInfo)
    },
    async todoInside({ row, insideInfo }) {
      // 遍历查询是否有配置“数据解析”字段，如果有配的话需要调接口获取解析的值
      if(Object.prototype.hasOwnProperty.call(row, 'transfile') && row.transfile && insideInfo.linked && insideInfo.linked.length > 0){
          const linkedFields = insideInfo.linked;
          let shouldDealInside = true; // 标记是否需要执行 dealInside
          for (const linkedField of linkedFields) {
              const valueKey = `${linkedField.title}_${linkedField.type}`;
              if(valueKey === 'data-analysis_text'){
                  const obj = {
                      approvalId: this.dataInfo.info.apply.id,
                      approvingId: row.approvingId
                  }
                  const res = await getapprovingfilecontent(obj)
                  if (res.code === 0) {
                      row['data-analysis'] = res.data
                      this.dealInside(row, insideInfo);
                      shouldDealInside = false;
                  }
                  break;
              }
          }
          if (shouldDealInside) {
            this.dealInside(row, insideInfo);
          }
      }
      else{
        this.dealInside(row,insideInfo)
      }
    },
    toBottom() {
      if (this.isNoList) return
      if (this.dataInfo.info.tableStyleField && this.dataInfo.info.tableStyleField.loadingMethod === 'scroll') {
        this.loading = true
        this.listInfo.currentPage += 1
        const obj = {
          curpage: 1,
          pagesize: this.listInfo.tablePageSize * this.listInfo.currentPage
        }
        this.handleChangePageInfo(obj)
      }
    },
    dealType (type) {
      const itype = this.organizationType.find(item => item.deptTipId === type) || {}
      return itype.name
    },
    labelView ({ val, type }) {
      const itype = this.organizationType.find(item => item.deptTipId === val) || {}
      if (itype.deptTipId > 9) {
        return typeObj[itype.colours] && typeObj[itype.colours][type]
      } else {
        return typeObj[itype.deptTipId] && typeObj[itype.deptTipId][type]
      }
    },
    async doorUp() {
      // TODO 刷新列表
      await this.handleListInfo(this.dataInfo.pageId, this.isSearchStatus ? this.searchText : '', this.querys)
      if (this.$refs.oneChild && this.$refs.oneChild.reCheckTable) {
        this.$refs.oneChild.reCheckTable()
      }
    },
    doorUpCloe() {
      // 弹窗关闭直接把变量改回之前的
      if (this.$store.state.doorCustomDataObj[this.customDeskId]) {
        const customData = this.$store.state.doorCustomDataObj[this.customDeskId]
        this.$store.commit('changeCustomData', { key: 'door', value: customData });
      }
      this.reloadScreen()
      this.openInput = {
          isVisible: false,
          approvalId: '',
          search: {},
          iId: ''
      },
      this.dialogInfo = {
        dialogName: '',
        isVisible: false,
        dialogWidth: '80%',
        dialogHeight: '85vh',
        openType: 'dialog',
        customSize: 65,
        dialogUrl: '',
        diaSize: '',
        childDialog: true
      }
    },
    openAppInitiate ({approvalId, name, search, iId, id, datatype, popUps, pageType}) {
      this.openInput = {
        isVisible: true,
        approvalId: approvalId,
        name: name,
        search: search,
        iId: iId,
        isDetail: [15, 16, 23, 24, 25].includes(iId) /*|| iId === 13 || iId === 14*/,
        id: id || '',
        datatype: datatype
      }
      const obj = {
        2: 'dialog',
        3: 'new',
        4: 'old',
        5: 'rightdia'
      }
      this.dialogInfo = {
        isVisible: true,
        dialogName: name,
        dialogWidth: popUps.w + 'px',
        dialogHeight: popUps.h + 'px',
        openType: obj[popUps.open],
        customSize: popUps.customSize,
        diaSize: popUps.diaSize,
        pageType: pageType || ''
      }
      this.openAddInputShow = true
    },
    async treeToSearch(data = {}, isGet = true) { 
      const chooseTag = this.organizationalStructure.chooseTag
      if (chooseTag !== 0 && chooseTag !== undefined && chooseTag !== data.type) {
        this.$refs.orgTree && this.$refs.orgTree.setCurrentKey(null);
        return
      }
      this.loading = true
      this.isSearchStatus = false
      if (this.organizationalStructure) {
        let querys = {}
        if (data.userId) {
          // 说明是查的联系人控件
          const filed = this.organizationalStructure.checkedUserFiled
          const condition = [{ userId: data.userId, realname: data.realname }]
          const _date = {
            [filed]: condition
          }
          if (this.searchCriteria.query) {
            querys = {
              ...this.querys,
              ...JSON.parse(this.searchCriteria.query),
              ..._date
            }
          } else {
            querys = { ...this.querys ,..._date }
          }
          this.organizationalParameters = _date
          this.currentUser = condition[0]
        } else {
          const filed = this.organizationalStructure.filterFields
          // query
          let objItem = ''
          const type = this.organizationalStructure.orgType
          if (type === 'userId') {
            objItem = `${filed.title}_${filed.type}`
          } else if (type === 'orgId') {
            objItem = this.organizationalStructure.orgId
          } else if (type === 'orgName') {
            objItem = this.organizationalStructure.orgName
          } else {
            objItem = `${filed.title}_${filed.type}`
          }
          if (objItem) {
            const _date = {
              [objItem]: getBottomLayerId({ data, type: type === 'orgName' ? 'name' : 'id', isChildren: this.isGradedManagement, chooseTag })
            }
            if (objItem.includes('organization')) {
              _date[objItem] = getBottomLayerId({ data, type: 'org', chooseTag })
            }
            if (this.organizationalStructure.userScreenMethods === 'orgId' && type === 'userId') {
              _date[objItem] && Array.isArray(_date[objItem]) && _date[objItem].push('organization')
            }
            if (this.searchCriteria.query) {
              querys = {
                ...this.querys,
                ...JSON.parse(this.searchCriteria.query),
                ..._date
              }
            } else {
              querys = { ...this.querys ,..._date }
            }
            this.organizationalParameters = _date
          }
          this.currentOrg = {
            id: data.organizationId || data.organizationid,
            name: data.name,
            looktype: data.looktype,
            type: data.type
          }
        }
        if (isGet) {
          this.handleListInfo(this.dataInfo.pageId, '', querys)
          if (this.$refs.splitScreen) {
            // 每次筛选都需要重新 去弄分屏的值
            const splitInfo = this.splitScreenInfo
            if (splitInfo && splitInfo.config && ['app-detail', 'app-comment'].includes(splitInfo.config.bindingFunction)) {
              await this.$refs.splitScreen.openDetail(this.listInfo.tableData[0])
            } else {
              const coverVal = await this.$refs.splitScreen.init()
              const screenRef = this.$refs.screenRef || []
              const ref = screenRef.find(c => (c.isUser && c.info.showMethods === 'tranL'))
              if (ref && ref.isDefaultFilterOpt) {
                const flag = await ref.getUserLink(coverVal)
                if (flag) {
                  await this.$refs.splitScreen.init()
                }
              }
            }
          }
        }
      }
    },
    // 卡片打开应用
    openApply (e) {
      let param = {
        approving: {
          approvingId: e.approvingId,
        },
        userapprovingId: e.userApprovingId,
        approvalId: this.$route.query.approvalId || this.dataInfo.info.apply.id,
      }
      this.$refs.AuditOpenChild.AuditOpenList(param, 1)
    },
    colorRgb (str, opacity) {
      var sColor = str.toLowerCase()
      if (sColor) {
        if (sColor.length === 4) {
          var sColorNew = '#'
          for (var i = 1; i < 4; i += 1) {
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
          }
          sColor = sColorNew
        }
        // 处理六位的颜色值
        var sColorChange = []
        // eslint-disable-next-line no-redeclare
        for (var i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
        }
        return 'rgba(' + sColorChange.join(',') + ',' + opacity + ')'
      } else {
        return sColor
      }
    },
    // 短信验证
    smsVerifi(key) {
      if (!this.dataInfo.info.apply.id) return
      let obj = {
        approvalId: this.dataInfo.info.apply.id,
        number: key // 验证参数为 1	个人数据查看短信验证 2 个人数据批量导出附件短信验证 3 个人数据批量导出报表短信验证 4 全校数据查看短信验证 5 全校数据批量导出附件短信验证 6 全校数据批量导出报表短信验证
      }
      if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        obj.upaceid = upaceId
      }
      openapiValidateapprovalsms(obj).then(res => {
        if (res.code === 0) {
          // bindcode 是否需要绑定手机号 smsverification 是否需要短信验证 phone 手机号
          this.validateType = 3
          this.toSmsVerifi = true
          if (res.data.smsverification && res.data.bindcode && !res.data.phone) {
            // 去绑定手机号
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.smsVerifi.iphoneBind({ isSmsView: true });
              }, 10);
            })
          } else if (res.data.smsverification && res.data.phone) {
            // 去验证
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.smsVerifi.openSmsVer(res.data.phone, this.toSmsVerifi ? { isSmsView: true } : '');
              }, 10);
            })
          } else {
            // 若不需要短信验证,则验证通过
            this.validateType = 4
            this.isPower = true
          }
        }
      }).catch(err => {
        console.log('短信验证错误', err)
      })
    },
    smsRefersh () {
      this.validateType = 4
    },
    whetherShow (type) {
      // 根据type获取表单验证数据内容
      let para = {
        approvalId: this.dataInfo.info.apply.id,
        number: type,
      };
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        para.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        para.upaceid = upaceId
      }
      getvalidateapproval(para).then(res => {
        if (res.data.property && res.data.property.length > 0) {
          this.toVeriQueryShow = true;
          this.validateType = 2
          this.$nextTick(() => {
            setTimeout(() => {
              const property = res.data.property
              const defaultId = res.data.default
              if (property.length===1) {
                if (!property[0].isDirectlyEnter) {
                  this.loading = false
                }
              } else if (defaultId) {
                let pro = property.find(item => { return item.appid === Number(defaultId) })
                if (pro && !pro.isDirectlyEnter) { 
                  this.loading = false
                }
              } else {
                this.loading = false
              }
              this.$refs.VerificationAndQueryInputRef.showList(res);
            }, 10)
          })
        } else {
          if (this.dataInfo.pageId === '6') {
            // 管辖数据不需要短信验证  所以提前排除
            this.validateType = 1
          } else {
            // 如果没有的话,则不需要表单验证,进行短信验证
            this.validateType = 4
            switch (this.dataInfo.pageId) {
              case '1':
                this.smsVerifi(1)
                break;
              case '7':
                this.smsVerifi(4)
                break;
            }
          }
        }
      }).catch(err => {
        console.log('getapproval 接口出错', err)
      })
    },
    formVerificationAndQuery (val) {
      // 表单验证返回之后 进行短信验证 如果是管辖数据 咋不需要短信验证
      this.validateType = 3
      switch (this.dataInfo.pageId) {
        case '1':
          this.smsVerifi(1)
          break;
        case '6':
          {
            this.validateType = 4
            const query = JSON.parse(val.querys)
            this.querys = {
              ...this.querys,
              ...query
            }
            this.handleListInfo('6','',query)
          }
          break;
        case '7':
          this.smsVerifi(4)
          break;
      }
    },
    async handlePowerPage (item) {
      switch (item) {
        case '1':
          this.handleDataPower(this.pagePower.personData, item)
          break;
        case '6':
          this.handleDataPower(this.pagePower.scopenData, item)
          break;
        case '7':
          this.handleDataPower(this.pagePower.allData, item)
          break;
      }
    },
    async getDataRecycleBin(key, query, params, ruledata) {
      const ref = this.$refs.recycleBin
      if (ref) {
        const opt = { key, query, params, ruledata }
        await ref.init(opt)
      }
    },
    handleDataPower (type, pageId) {
      // 根据获取的信息去判断有无权限 为空对象则无权限 无权限之后就不需要在判断后面是否还有权限
      if (JSON.stringify(type) === '{}') {
        this.validateType = 1
        this.isPower = false
      } else {
        // 若不是空对象,则继续进行表单验证
        this.isPower = true
        if (pageId === '1') {
          this.whetherShow(1)
          this.validatePage = 1
        } else if (pageId === '6') {
          this.whetherShow(3)
          this.validatePage = 3
        } else if (pageId === '7') {
          this.whetherShow(2)
          this.validatePage = 2
        }
      }
    },
    async getPowerPage () {
      // 获取个人数据 管辖数据 全部数据 填写表单的权限
      // 个人数据
      let personData = {}
      // 管辖数据
      let scopenData = {}
      // 全部数据
      let allData = {}
      // 填写表单权限
      let writeTable = {}
      const par = {
        appid: this.dataInfo.info.apply.id,
        datatype: 1
      }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        par.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        par.upaceid = upaceId
      }
      const res = await axiosBase(par, "/openapi/getappper")
      if (res.data.length !== 0) {
        // 页面权限判断
        res.data.forEach(item => {
          switch (item.key) {
            case "approvalid":
              writeTable = item
              break;
            case "myreportformid":
              personData = item
              break;
            case "scopeid":
              scopenData = item
              break;
            case "reportFormid":
              allData = item
              break;
          }
        })
      }
      this.pagePower = {
        personData,
        scopenData,
        allData,
        writeTable
      }
      this.handlePowerPage(this.dataInfo.pageId)
    },
    async hanldePower(key) {
      // 如果是管辖数据需要加上一个datatype
      if (this.dataInfo.info.apply && !this.dataInfo.info.apply.id) return
      let obj = {
        approvalId: this.dataInfo.info.apply.id || this.dataInfo.info.apply.approvalId,
        pagesize: 0,
        curpage: 0,
      }
      if (this.dataInfo.pageId === '6') {
        obj.datatype = 1
      }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        obj.spaceid = spaceId;
      } else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        obj.upaceid = upaceId
      }
      // 请求数据
      const { data } = await getopenreportformlist(obj)
      if (data) {
        // 获取表单填写页配置信息
        await this.getApperInfo(this.dataInfo.info.apply.id)

        // 替换表单选中的字段
        // await this.replaceSelectField(this.dataInfo.info.apply.id)

        // 增加字段的配置
        this.addFieldConfig(data[0])
        // 遍历判断是否有userId如果有userId的话，则为个人数据，否则为全部数据
        // '1'为全部数据的储存点  '0'为个人数据的储存点
        data.forEach((item) => {
          if (item.userId) {
            this.powerData['0'] = item
          } else {
            this.powerData['1'] = item
          }
        })
        this.jurisdictionData = data
        this.setJurisdiction() //根据pageId 选出 个人数据&全部数据(此处操作为了获取表格中的按钮权限)
        // if (data.length == 2) {
        // }
        // 获取了权限数据后,再去判断页面的权限数据,再请求表单数据
        // 判断页面权限数据
        this.getPowerPage()
        // 获取代办点数
        let isGetNum = false
        for (const key of ['1', '2', '3']) {
          if (this.dataInfo.info[key]) {
            isGetNum = true
            break
          }
        }
        if (isGetNum) {
          this.getAgencyNum(this.dataInfo.info.apply.id)
        }

        this.setDefaultFiled()


        if (this.splitScreenInfo && this.splitScreenInfo.defaultPrecent) {
          if (this.isInitTableAndOpenScreen) {
            if (this.splitPanelSlot === 'paneF') {
              this.defaultPrecent = 0
            } else {
              this.defaultPrecent = 100
            }
          } else {
            this.defaultPrecent = this.splitScreenInfo.defaultPrecent
          }
        }

        // 由于管辖数据需要带query再请求此役 所以管辖数据这边不请求
        if (!['6'].includes(this.dataInfo.pageId)) {
          // flag 默认是去请求数据  如果说有筛选组件的话就不去请求了
          let flag = true
          // 再去判断是否需要请求数据 因为如果说带有筛选组件 并且有默认值，会重复请求数据，现在需要去判断一下
          // 处理 筛选组件的默认值
          flag = this.dealScreenOpt(this.getScreen)
          // 由于 组织选择打开了，组织那边会默认请求一次，这边初始化在请求就会出问题。
          if (flag && !(this.isOpenOrg)) {
            if (this.dataInfo.info.tableStyleField.isInitTable !== false) {
              await this.handleListInfo(this.dataInfo.pageId, '', key ? key : {})
              if (this.$refs.splitScreen) {
                // 每次筛选都需要重新 去弄分屏的值
                const splitInfo = this.splitScreenInfo
                if (splitInfo && splitInfo.config && ['app-detail', 'app-comment'].includes(splitInfo.config.bindingFunction)) {
                  await this.$refs.splitScreen.openDetail(this.listInfo.tableData[0])
                } else {
                  const coverVal = await this.$refs.splitScreen.init()
                  const screenRef = this.$refs.screenRef || []
                  const ref = screenRef.find(c => (c.isUser && c.info.showMethods === 'tranL'))
                  if (ref && ref.isDefaultFilterOpt) {
                    const flag = await ref.getUserLink(coverVal)
                    if (flag) {
                      await this.$refs.splitScreen.init()
                    }
                  }
                }
              }
            } else {
              this.loading = false
            }
          }
        }
      } else {
        this.$message.error('请求错误')
      }
    },
    addFieldConfig (data) {
      if (data && data.userReport && data.userReport.content) {
        const content = JSON.parse(data.userReport.content)
        content.forEach(item => {
          // 联系人把这两个配置加上去
          if (item.type === 'relation-user') {
            const name = `${item.title}_${item.type}`
            const i = this.dataInfo.info.checkSyllable.findIndex(iter => name === `${iter.title}_${iter.type}`)
            if (i !== -1) {
              const syllable = this.dataInfo.info.checkSyllable[i]
              syllable.isMoreInfo = item.isMoreInfo
              syllable.moreInfoArr = item.moreInfoArr
              // eslint-disable-next-line vue/no-mutating-props
              this.dataInfo.info.checkSyllable[i] = syllable
            }
          } else if (item.type === 'date' && item.timeList) {
            const name = `${item.title}_${item.type}`
            const i = this.dataInfo.info.checkSyllable.findIndex(iter => name === `${iter.title}_${iter.type}`)
            if (i !== -1) {
              const syllable = this.dataInfo.info.checkSyllable[i]
              syllable.timeList = item.timeList
              // eslint-disable-next-line vue/no-mutating-props
              this.dataInfo.info.checkSyllable[i] = syllable
            }
          } else if (item.type === 'file') {
            const name = `${item.title}_${item.type}`
            const i = this.dataInfo.info.checkSyllable.findIndex(iter => name === `${iter.title}_${iter.type}`)
            if (i !== -1) {
              const iten = this.appProperty.find(iten => { return iten.title === item.title })
              if (iten && iten.isFileEdit) {
                const syllable = this.dataInfo.info.checkSyllable[i]
                syllable.isFileEdit = true
                // eslint-disable-next-line vue/no-mutating-props
                this.dataInfo.info.checkSyllable[i] = syllable
              }
            }
          }
        })
      }
    },
    dealScreenOpt(arr = []) {
      if (this.dataInfo.info.clickEffect && this.dataInfo.info.clickEffect.toolNav === 'close') return true
      return dealScreenOpt(arr)
    },
    // 这个方法为仪表盘更新专用
    handlerQuery (obj) {
      this.searchYb = JSON.parse(JSON.stringify(obj))
      this.handleListInfo(this.dataInfo.pageId, '', this.searchCriteria.query || {})
    },
    dealQueryStr(str) {
      if (!str) return
      const query = typeof str === 'string' ? JSON.parse(str) : str
      return query
    },
    // 处理判断点击的是哪个页面，然后根据pageId去请求接口
    async handleListInfo (pageId, key = '', query = {}, status = '0', params = {}, otherConfig = { isGetData: false }) {
      // isGetData 仅获取数据 不改变列表数据
      if (!this.dataInfo.info.apply.id) return
      // params额外增加的参数
      if (this.splitScreenInfo && this.splitScreenInfo.config && this.splitScreenInfo.config.splitInfo && this.splitScreenInfo.config.splitInfo.listAppen === 'hidden') {
        this.loading = true
      }
      this.setRefreshTime()
      if (Object.keys(this.organizationalParameters).length !== 0) {
        const searchquery = this.dealQueryStr(query)
        query = {
          ...searchquery,
          ...this.organizationalParameters
        }
      }
      let ruledata = {}
      if (this.dataInfo.info.rulerData) {
        ruledata = JSON.parse(JSON.stringify(this.dataInfo.info.rulerData))
        if (ruledata.fixquery) {
          ruledata.fixquery = dealFixQuery(ruledata.fixquery, this.customParams, this.customDeskId)
        }
      }
      if (this.ruledata.fixquery) {
        ruledata.fixquery = {
          ...this.ruledata.fixquery,
          ...ruledata.fixquery,
        }
        if (ruledata.fixquery.ov === undefined) {
          ruledata.fixquery.ov = 'and'
        }
      }
      this.ruledata = ruledata
      query = {
        ...this.dealQueryStr(query),
        ...this.dealQueryStr(this.searchCriteria.query)
      }
      // 仪表盘查询参数合并
      if (JSON.stringify(this.searchYb) !== '{}') {
        if (typeof query === 'string') query = JSON.parse(query)
        for (const i in this.searchYb) {
          if (query[i]) {
            const a = [...this.searchYb[i], ...query[i]]
            query[i] = [...new Set(a)]
          } else {
            query[i] = this.searchYb[i]
          }
        }
        if (typeof query === 'object') query = JSON.stringify(query)
      }
      if (pageId === '6') {
        params.datanum = 1
        if (typeof query === 'string') {
          query = {
            ...JSON.parse(query),
            ...this.querys
          }
        } else {
          query = {
            ...query,
            ...this.querys
          }
        }
      }
      if (this.customStatusQuery.step && this.customStatusQuery.step.length !== 0) {
        query = {
          ...query,
          ...this.customStatusQuery
        }
      }

      if (Object.keys(this.titleQeury).length !== 0) {
        query = {
          ...query,
          ...this.titleQeury
        }
      }
      if (this.titleOrder.length !== 0) {
        if (ruledata.fixorder) {
          ruledata.fixorder.push(...this.titleOrder)
        } else {
          ruledata.fixorder = this.titleOrder
        }
      }
      this.totalParams = Object.assign(this.totalParams, {
        key,
        query,
        params,
        ruledata,
        status
      })
      if (this.dataInfo.info.tableStyleField.filedType === 'pivot') {
        await this.getPivotDataInfo(this.totalParams, otherConfig)
      } else {
        try {
          switch (pageId) {
            case '1':
              // 我填报的
              await this.getWriteListInfo(key, query, params, ruledata, otherConfig)
              break
            case '2':
              // 待我处理的
              await this.getPeddingListInfo(key, query, params, ruledata)
              break
            case '3':
              // 待阅
              await this.getTreatViewListInfo(key, query, status, params)
              break
            case '4':
              // 我已处理
              await this.getProcessedListInfo(key, query, params, ruledata)
              break
            case '5':
              // 关于我的
              await this.getAboutMeListInfo(key, query, params, ruledata)
              break
            case '6':
              // 管辖数据
              await this.getAllDataListInfo(key, query, params, ruledata)
              break
            case '7':
              // 全部数据
              await this.getAllDataListInfo(key, query, params, ruledata, otherConfig)
              break
            case '10':
              // 回收站
              await this.getDataRecycleBin(key, query, params, ruledata)
              break
            case '8':
              // 提交统计
              this.iframeUrl = `/clientSide/workbench/CycleFillingSetting/CycleFillingSetting?approvalId=${this.dataInfo.info.apply.id}`
              break
            case '9':
              // 区块链统计
              {
                const { blockchainData, id } = this.dataInfo.info.apply
                if (blockchainData && blockchainData != '') {
                  if (blockchainData.chaininstall != 0) {
                    this.iframeUrl = `https://open.xmedu.cn/qkl/xmedu/?appid=${id}`
                  }
                } else {
                  this.iframeUrl = '/blockchainNodata?name=本应用未上区块链';
                }
              }
              break
          }
        } catch (error) {
          this.loading = false
        }
      }
      // 选中清空
      this.multipleSelection = []
      if (this.$refs.oneChild && this.$refs.oneChild.clearCheckboxRow) {
        this.$refs.oneChild.clearCheckboxRow()
      }
      this.loading = false
    },
    async getWriteListInfo (key, query, params = {}, ruleData = {}, otherConfig = {}) {
      // 获取我填报的数据
      if (!this.powerData['0'].reportFormId) return
      const param = {
        type: 0,
        curpage: this.listInfo.currentPage,
        pagesize: this.listInfo.tablePageSize,
        approvalId: this.dataInfo.info.apply.id,
        key,
        query,
        reportFormId: this.powerData['0'].reportFormId,
        ...params,
        ...ruleData
      }
      if (otherConfig.isGetData) {
        param.curpage = otherConfig.currentPage !== undefined ? otherConfig.currentPage : this.listInfo.currentPage
        param.pagesize = otherConfig.pagesize !== undefined ? otherConfig.pagesize : this.listInfo.tablePageSize
      }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        param.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        param.upaceid = upaceId
      }
      const res = await axiosBase(param, '/api/getuserfielddatalist')
      if (res.code === 0) {
        if (otherConfig.isGetData) {
          this[otherConfig.saveKey] = res.data
          this.toImportData()
        } else {
          if (res.data.length === res.total) this.isNoList = true
          this.listInfo.currentPage = res.curpage
          this.listInfo.tableTotal = res.total
          this.listInfo.tableData = this.dealReadNum(res.data)
          this.listInfo.tablePageSize = res.pagesize
        }
      } else {
        if (res.code === -1 && res.msg === "您没有权限") {
          this.validateType = 1
        }
      }
    },
    async getPeddingListInfo (key, query, params, ruleData = {}) {
      // 获取待我处理的数据
      if (!this.powerData['0'].reportFormId) return
      const param = {
        type: 1,
        status: '0',
        way: '0,1,2,4',
        curpage: this.listInfo.currentPage,
        pagesize: this.listInfo.tablePageSize,
        approvalId: this.dataInfo.info.apply.id,
        key,
        query,
        reportFormId: this.powerData['0'].reportFormId,
        ...params,
        ...ruleData
      }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        param.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        param.upaceid = upaceId
      }
      const res = await axiosBase(param, '/api/getuserfielddatalist')
      if (res.code === 0) {
        if (res.data.length === res.total) this.isNoList = true
        this.listInfo.currentPage = res.curpage
        this.listInfo.tableTotal = res.total
        this.listInfo.tableData = this.dealReadNum(res.data)
        this.listInfo.tablePageSize = res.pagesize
      } else {
        if (res.code === -1 && res.msg === "您没有权限") {
          this.validateType = 1
        }
      }
    },
    async getTreatViewListInfo (key, query, status, params) {
      // 获取待阅的数据
      const param = {
        type: 1,
        way: '0,1,2,4',
        status,
        curpage: this.listInfo.currentPage,
        pagesize: this.listInfo.tablePageSize,
        key,
        ...query,
        approvalId: this.dataInfo.info.apply.id,
        ...params
      }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        param.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        param.upaceid = upaceId
      }
      const res = await axiosBase(param, '/openapi/getuserccapprovallist')
      if (res.code === 0) {
        if (res.data.length === res.total) this.isNoList = true
        this.listInfo.currentPage = res.curpage
        this.listInfo.tableTotal = res.total
        this.listInfo.tableData = this.dealReadNum(res.data)
        this.listInfo.tablePageSize = res.pagesize
      } else {
        if (res.code === -1 && res.msg === "您没有权限") {
          this.validateType = 1
        }
      }
    },
    async getProcessedListInfo (key, query, params, ruleData = {}) {
      // 获取我已处理的数据
      if (!this.powerData['0'].reportFormId) return
      const param = {
        type: 1,
        way: '0,1,2,4',
        status: '1,2',
        curpage: this.listInfo.currentPage,
        pagesize: this.listInfo.tablePageSize,
        approvalId: this.dataInfo.info.apply.id,
        key,
        query,
        reportFormId: this.powerData['0'].reportFormId,
        ...params,
        ...ruleData
      }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        param.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        param.upaceid = upaceId
      }
      const res = await axiosBase(param, '/api/getuserfielddatalist')
      if (res.code === 0) {
        if (res.data.length === res.total) this.isNoList = true
        this.listInfo.currentPage = res.curpage
        this.listInfo.tableTotal = res.total
        this.listInfo.tableData = this.dealReadNum(res.data)
        this.listInfo.tablePageSize = res.pagesize
      } else {
        if (res.code === -1 && res.msg === "您没有权限") {
          this.validateType = 1
        }
      }
    },
    async getAboutMeListInfo (key, query, params, ruleData = {}) {
      // 获取关于我的数据
      if (!this.powerData['0'].reportFormId) return
      const param = {
        type: 0,
        selfuser: 0,
        curpage: this.listInfo.currentPage,
        pagesize: this.listInfo.tablePageSize,
        approvalId: this.dataInfo.info.apply.id,
        key,
        query,
        reportFormId: this.powerData['0'].reportFormId,
        ...params,
        ...ruleData
      }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        param.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        param.upaceid = upaceId
      }
      const res = await axiosBase(param, '/api/getuserfielddatalist')
      if (res.code === 0) {
        if (res.data.length === res.total) this.isNoList = true
        this.listInfo.currentPage = res.curpage
        this.listInfo.tableTotal = res.total
        this.listInfo.tableData = this.dealReadNum(res.data)
        this.listInfo.tablePageSize = res.pagesize
      } else {
        if (res.code === -1 && res.msg === "您没有权限") {
          this.validateType = 1
        }
      }
    },
    async getAllDataListInfo (key, query, params, ruleData = {}, otherConfig = {}) {
      // 获取全部数据
      const pageid = this.dataInfo.pageId
      if (!this.powerData['1'].reportFormId) return
      const param = {
        type: 0,
        curpage: cloneDeep(this.listInfo.currentPage),
        pagesize: cloneDeep(this.listInfo.tablePageSize),
        approvalId: this.dataInfo.info.apply.id,
        key,
        query,
        reportFormId: this.powerData['1'].reportFormId,
        ...params,
        ...ruleData
      }
      if (otherConfig.isGetData) {
        param.curpage = otherConfig.currentPage !== undefined ? otherConfig.currentPage : this.listInfo.currentPage
        param.pagesize = otherConfig.pagesize !== undefined ? otherConfig.pagesize : this.listInfo.tablePageSize
        if (otherConfig.query) {
          param.query = { ...param.query, ...otherConfig.query }
        }
      }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        param.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        param.upaceid = upaceId
      }
      if (pageid === '6') {
        param.querys = query
        delete param.query
      }
      // ai小易配置隐藏，则获取全部数据
      if(this.aitableHide){
        param.pagesize = 0
      }
      const res = await axiosBase(param, '/api/getfielddatalist')
      if (res.code === 0) {
        if (otherConfig.isGetData) {
          this[otherConfig.saveKey] = res.data
          this.toImportData()
        } else {
          if (res.data.length === res.total) this.isNoList = true
          this.listInfo.currentPage = res.curpage
          this.listInfo.tableTotal = res.total
          this.listInfo.tableData = this.dealReadNum(res.data)
          this.listInfo.tablePageSize = res.pagesize
          const arr = this.dataInfo.info.checkSyllable.filter(item => { return item.isFormula })
          if (arr.length > 0) {
            try {
              this.listInfo.tableData = setFormulaValue(arr, res.data, this.appProperty)
            } catch (error) {
              console.log('函数计算错误', error)
            }
          }
          // 老谭说 重新请求所有数据
          if (!this.isPageChange && this.isAppenScreen) {
            param.curpage = 1
            param.pagesize = 1
            this.isPageChange = false
          }
        }

      } else {
        if (res.code === -1 && res.msg === "您没有权限") {
          this.validateType = 1
        }
      }
    },
    // 处理一下阅读数等字段的数据
    dealReadNum (data = []) {
      return data.map(item => {
        const obj = {
          阅读数: (item.read || 0) + '',
          点赞数: (item.point || 0) + '',
          收藏数: (item.collect || 0) + '',
          转发数: (item.forward || 0) + ''
        }
        return { ...obj, ...item }
      })
    },
    // 切换页面
    switchPage (item) {
      this.listInfo.currentPage = 1
      // eslint-disable-next-line vue/no-mutating-props
      this.dataInfo.pageId = item.value
      this.screenQuery = {}
      this.screenSearch = {}
      this.screenFixQuery = {}
      if (item.value === '6') {
        // 如果是管辖数据 需要重新请求一下数据
        this.hanldePower()
      }
      this.setJurisdiction()
    },

    scrollChange(type = 'next') {
      let curpage = this.listInfo.currentPage
      this.loading = true
      if (type === 'next') {
        curpage++
      } else if (type === 'prev') {
        curpage--
      }
      this.listInfo.currentPage = curpage
      const obj = {
        curpage,
        pagesize: this.listInfo.tablePageSize
      }
      this.handleChangePageInfo(obj)
    },
    handleChangePageInfo(par, type) {
      this.loading = true
      let query = {
        ...this.querys,
        ...this.organizationalParameters,
        ...JSON.parse(this.searchCriteria.query)
      }
      let key = ''
      if (this.isSearchStatus) {
        key = this.searchText
        query = {
          ...query,
          ...this.searchCompQuery
        }
      }
      let info = {}
      if (type === 'pageSize') {
        info = {
          pagesize: par
        }
      } else if (type === 'currentPage') {
        info = {
          curpage: par
        }
      }
      const params = { ...par,...info } || {}
      this.isPageChange = true
      this.handleListInfo(this.dataInfo.pageId, key, query, '0', params)
    },
    // 筛选组件修改时触发，
    handelChangeVal () {
    },
    async changeNewRelRadio(val = {}, id){
      const query = {}
      for(let key in val) {
        const curValue = val[key]
        if (key.includes('new-rel-radio')) {
          delete val[key]
        } else {
          if (typeof curValue === 'string') {
            if (curValue) {
              query[key] = [val[key]]
            }
          } else if (Array.isArray(curValue)) {
            query[key] = val[key]
          } else {
            query[key] = [val[key]]
          }
        }
      }
      this.querys = { ...this.querys, ...query }
      if (this.isInitTable) { 
        const idx = this.initList.findIndex(c=> c === id)
        if (idx === -1) {
          this.initList.push(id)
        }
        const isInit = this.getInitList(id)
        if (isInit) {
          await this.handleListInfo(this.dataInfo.pageId, this.isSearchStatus ? this.searchText : '', this.querys)
          this.isGetListData = true
          this.defaultPrecent = this.splitScreenInfo.defaultPrecent
          this.initCount++
        } else if (this.isGetListData) {
          await this.handleListInfo(this.dataInfo.pageId, this.isSearchStatus ? this.searchText : '', this.querys)
        }
      } else {
        await this.handleListInfo(this.dataInfo.pageId, this.isSearchStatus ? this.searchText : '', this.querys)
      }
      if (this.$refs.splitScreen) {
        // 每次筛选都需要重新 去弄分屏的值
        const splitInfo = this.splitScreenInfo
        if (splitInfo && splitInfo.config && ['app-detail', 'app-comment'].includes(splitInfo.config.bindingFunction)) {
          await this.$refs.splitScreen.openDetail(this.listInfo.tableData[0])
        } else {
          const coverVal = await this.$refs.splitScreen.init()
          const screenRef = this.$refs.screenRef || []
          const ref = screenRef.find(c => (c.isUser && c.info.showMethods === 'tranL'))
          if (ref && ref.isDefaultFilterOpt) {
            // 选项值 才继续走联动
            const flag = await ref.getUserLink(coverVal)
            if (flag) {
              await this.$refs.splitScreen.init()
            }
          }
        }
      }
    },
    dealSearchScreenValue() {
      if (!this.isInitTable) return true
      const list = this.dataInfo.info.initConfig.list
      for (const ele of list) {
        const value = this.isSearchScreenValue[ele]
        if (Array.isArray(value) && value.length === 0) {
          return false
        } else if (value && JSON.stringify(value) === '{}') {
          return false
        }
      }
      return true
    },
    async screenNewChange(e) {
      let { value, condition, type, title, values, isSearch = true, isData = true, id, filterValueObj = {}, isScreenTree = false, childScreen = {}, parent = '' } = e
      let isGetData = true
      if (filterValueObj && Object.keys(filterValueObj).length) {
        this.filterValueQuery = { ...this.filterValueQuery, ...filterValueObj }
        Object.keys(this.filterValueQuery).forEach(key => {
          if (this.filterValueQuery[key].length === 0) {
            if (this.querys[key] !== undefined) {
              delete this.querys[key]
            }
            delete this.filterValueQuery[key]
          }
        })
      }
      if (isScreenTree) {
        this.isSearchScreenValue[id] = filterValueObj
      } else {
        this.isSearchScreenValue[id] = value
      }
      let isIncludeInit = false
      if (this.isInitTable) {
        const item = this.dataInfo.info.initConfig.list.find(c => c === id)
        isIncludeInit = !!item
      }
      this.querys = {
        ...this.querys,
        ...childScreen
      }
      if (condition && !isScreenTree && !parent) {
        // 处理需要条件的
        if (condition.val !== 'between' && type === 'number') {
          value = value[0]
        }
        if (type === 'timeof') {
          type = 'date'
        }
        // 由于 申请人和申请时间 要走fixquery
        const typeName = {
          appuser: '申请人',
          date: '提交时间'
        }
        let submitName = `${typeName[title] || title}_${type}`
        if(typeName[title] === '提交时间') {
          submitName = `提交时间_提交时间`
        }
        const obj = {
          title,
          type,
          submitName,
          conditionName: condition.name,
          condition: condition.val,
          conditionValue: value,
          isCutom: condition.isCustom
        }
        if (type === 'date' && condition.isCustom) {
          obj.isCutom = true
        }
        const data = {
          linked: [obj]
        }
        const fixquery = dealFixQuery(data, this.customParams, this.customDeskId)
        delete fixquery.ov
        // 筛选组件中需要走 fixquery的参数
        if (fixquery[submitName] && isSearch) {
          if (this.isInitTable && this.dataInfo.info.initConfig && isIncludeInit) {
            const idx = this.initList.findIndex(c=> c === id)
            if (idx === -1) {
              this.initList.push(id)
            }
          }
          this.screenFixQuery = {
            ...this.screenFixQuery,
            ...fixquery
          }
        } else {
          if (this.isInitTable) {
            const idx = this.initList.findIndex(c=> c === id)
            if (idx !== -1) {
              this.initList.splice(idx, 1)
              isGetData = false
            }
          }
        }
      } else if ((title !== undefined && type !== undefined && !isScreenTree) || (title === '状态' && type === undefined && !isScreenTree) || (parent && !isScreenTree)) {
        let _type = `${title}_${type}`
        if (title === 'status' || title === '状态') {
          if (type === undefined) {
            _type = 'status_status'
          }
          if (typeof value[0] === 'object') {
            const defaultStatus = value.filter(c => c.step === undefined).map(c=>c.status)
            const customStatus = value.filter(c => c.step !== undefined).map(c=>({value: c.step, status: c.status}))
            value = defaultStatus
            this.customStatusQuery.step = cloneDeep(customStatus)
          } else {
            const valObj = {
              已通过:'1',
              待审批:'0',
              未通过:'2',
              已撤回:'3',
              进行中:'0',
            }
            value = value.map(item=> valObj[item])
            this.customStatusQuery = {
              step: []
            }
          }
        }
        let obj = {}
        if (parent) {
          obj = {
            [`${parent}@${_type}`]: value
          }
        } else {
          obj = {
            [_type]: value
          }
        }
        if ((values && JSON.stringify(values) !== '[]' && Array.isArray(values) && values[0] !== '_全部_' && isSearch) || (parent && isSearch)) {
          if (this.isInitTable && this.dataInfo.info.initConfig && this.dataInfo.info.initConfig.list.find(c => c === id)) {
            const idx = this.initList.findIndex(c=> c === id)
            if (idx === -1) {
              this.initList.push(id)
            }
          }
          this.screenQuery = {
            ...this.screenQuery,
            ...obj
          }
        } else {
          delete this.screenQuery[_type]
          delete this.querys[_type]
          if (this.isInitTable) {
            const idx = this.initList.findIndex(c=> c === id)
            if (idx !== -1) {
              this.initList.splice(idx, 1)
              isGetData = false
            }
          }
        }
      }
      this.$set(this.screenSearch, id, true)
      // 筛选关联
      if (this.screenRelation[id]) {
        this.screenRelation[id].forEach(item => {
          if (this.getIdScreenRef[item.i]) {
            if (this.getIdScreenRef[item.i].$refs.screenTreeRef) {
              this.getIdScreenRef[item.i].$refs.screenTreeRef.getTreeData()
            } else {
              this.getIdScreenRef[item.i].init(true, id)
            }
            // 开启了变量提示
            if (this.getIdScreenRef[item.i].info.variableTips) {
              this.getIdScreenRef[item.i].expandSelect(true)
            }
          }
        })
        if (this.screenRelation[id].length > 0) {
          this.loading = false
          return false
        }
      }
      if (this.screenNum === Object.keys(this.screenSearch).length) {
        this.isFirstInitScreenCount++
        // 当筛选组件的数量 和 screenSearch中的 长度一样 就可以请求接口了  否则会请求多次
        const screenFixQuery = cloneDeep(this.screenFixQuery)
        // 判断是否需要把数据置空  欧总那边需求  筛选组件为空的时候  需要置空数组  true为不要置空
        for (const key in screenFixQuery) {
          const query = screenFixQuery[key].value
          if (key.includes('relation-user') || key.includes('organization') || key.includes('roule') || key.includes('date')) {
            // 单独联系人控件
            if ((query.length >= 1 && (query[0] === '' || query[0] === null || query[0] === undefined || Number.isNaN(query[0]))) || query.length === 0 || (value.length === 0 && !key.includes('date'))) {
              delete screenFixQuery[key]
              delete this.screenFixQuery[key]
              if (this.ruledata.fixquery && this.ruledata.fixquery[key]) delete this.ruledata.fixquery[key]
            }
          }
        }
        this.ruledata.fixquery = cloneDeep({
          ov: 'and',
          ...this.ruledata.fixquery,
          ...screenFixQuery
        })
        this.querys = {
          ...this.querys,
          ...this.screenQuery,
          ...this.filterValueQuery
        }
        if (isScreenTree && Object.keys(this.filterValueQuery).length === 0 && isData && this.isInitTable && isGetData && isIncludeInit) isGetData = false
        for (const key in this.querys) {
          const query = this.querys[key]
          if (!isSearch && this.querys[`${title}_${type}`]) {
            delete this.querys[`${title}_${type}`]
            continue
          }
          if ((query.length === 1 && (query[0] === '' || query[0] === null || query[0] === undefined)) || query.length === 0) {
            delete this.querys[key]
          }
        }

        // 当前页变成第一页
        this.listInfo.currentPage = 1
        if (isData || (this.isFirstInitScreenCount === 1)) {
          // 是否获取数据
          if (this.isInitTable) {
            const isInit = this.getInitList(id)
            if (isInit) {
              isGetData = this.dealSearchScreenValue()
              if (isGetData) {
                this.loading = true
                await this.handleListInfo(this.dataInfo.pageId, this.isSearchStatus ? this.searchText : '', this.querys)
                this.isGetListData = true
                if (this.$refs.splitScreen) {
                  const splitInfo = this.splitScreenInfo
                  if (splitInfo && splitInfo && splitInfo.config && ['app-detail', 'app-comment'].includes(splitInfo.config.bindingFunction)) {
                    await this.$refs.splitScreen.openDetail(this.listInfo.tableData[0])
                  } else {
                    const coverVal = await this.$refs.splitScreen.init()
                    const screenRef = this.$refs.screenRef || []
                    if (screenRef) {
                      const ref = screenRef.find(c => (c.isUser && c.info.showMethods === 'tranL'))
                      if (ref && ref.isDefaultFilterOpt) {
                        const flag = await ref.getUserLink(coverVal)
                        if (flag) {
                          await this.$refs.splitScreen.init()
                        }
                      }
                    }
                  }
                }
              } else {
                this.listInfo = {
                  tableData: [],
                  tableTotal: 0,
                  currentPage: 1,
                  tablePageSize: 25,
                }
                if(this.dataInfo.info.tableStyleField && this.dataInfo.info.tableStyleField.pageNum) {
                  this.listInfo.tablePageSize = getPageSize(this.dataInfo.info.tableStyleField, 25)
                }
                this.isGetListData = false
              }
              this.defaultPrecent = this.splitScreenInfo.defaultPrecent
              this.initCount++
              this.loading = false
            } else if (this.isGetListData) {
              // 不在初始化数据列表里面的筛选组件走
              this.loading = true
              await this.handleListInfo(this.dataInfo.pageId, this.isSearchStatus ? this.searchText : '', this.querys)
            }
          } else {
            this.loading = true
            await this.handleListInfo(this.dataInfo.pageId, this.isSearchStatus ? this.searchText : '', this.querys)
            if (this.$refs.splitScreen) {
              const splitInfo = this.splitScreenInfo
              if (splitInfo && splitInfo && splitInfo.config && ['app-detail', 'app-comment'].includes(splitInfo.config.bindingFunction)) {
                await this.$refs.splitScreen.openDetail(this.listInfo.tableData[0])
              } else {
                const coverVal = await this.$refs.splitScreen.init()
                const screenRef = this.$refs.screenRef || []
                if (screenRef) {
                  const ref = screenRef.find(c => (c.isUser && c.info.showMethods === 'tranL'))
                  if (ref && ref.isDefaultFilterOpt) {
                    const flag = await ref.getUserLink(coverVal)
                    if (flag) {
                      await this.$refs.splitScreen.init()
                    }
                  }
                }
              }
            }
          }
        } else {
          if (this.dataInfo.info.initConfig && this.dataInfo.info.initConfig.list) {
            const list = this.dataInfo.info.initConfig.list
            const idx = list.indexOf(id)
            if (idx > -1) {
              const ref = this.getIdScreenRef[id]
              if (ref && ref.screenResValue && ref.screenResValue.length === 0) {
                this.listInfo = {
                  tableData: [],
                  tableTotal: 0,
                  currentPage: 1,
                  tablePageSize: 25,
                }
                if (this.dataInfo.info.tableStyleField && this.dataInfo.info.tableStyleField.pageNum) {
                  this.listInfo.tablePageSize = getPageSize(this.dataInfo.info.tableStyleField, 25)
                }
                this.isGetListData = false
              }
            }
          }
        }
      }
    },
    screenChange () {
      let screenArr = this.layout[0].info.filter(item => item.type === 'screen')
      let query = {};
      screenArr.forEach((el) => {
        if (this.dataInfo.pageId == 3) {   //待阅页面status、date传参格式与其他页面不同
          if (el.screenType == "status") {
            query["state"] = el.value.toString()
          } else if (el.screenType == "date" || el.screenType == "timeof") {
            query["startTime"] = el.value ? new Date(el.value[0]).getTime() : ''
            query["endTime"] = el.value ? new Date(el.value[1]).getTime() : ''
          } else if (el.screenType == "number") {
            query[el.title + "_" + el.screenType] = [el.value];
          } else {
            query[el.title + "_" + el.screenType] = el.value;
          }
        } else {
          if (el.screenType == "date" && !el.value) {
            query[el.title + "_" + el.screenType] = [];
          } else if (el.screenType == "number") {
            query[el.title + "_" + el.screenType] = [el.value];
          } else {
            query[el.title + "_" + el.screenType] = el.value;
          }
        }
      });
      Object.keys(query).forEach(item => {
        const val = query[item]
        const isArr = Array.isArray(val) && val.length === 0
        const isObj = typeof val === 'object' && Object.keys(val).length === 0
        const isStr = typeof val === 'string' && val === ''
        if (isArr || isObj || isStr) delete query[item]
      })
      this.querys = query
      this.handleListInfo(this.dataInfo.pageId, this.isSearchStatus ? this.searchText : '', query)
    },
    handleNavBarIcon (value) {
      // 处理页面图标转化
      switch (value) {
        case 'icontianbao1':
          return 'icon-a-tianbao2x'
        case 'iconjishishalou':
          return 'icon-a-jishishalou2x'
        case 'iconchakan1':
          return 'icon-a-chakan2x'
        case 'iconchakanfuzhi':
          return 'icon-a-chakanfuzhi2x'
        case 'iconyonghu':
          return 'icon-lianxirenkongjian'
        case 'iconbiaodanguanli':
          return 'icon-a-biaodanguanli2x'
        case 'iconguanxia':
          return 'icon-a-guanxia2x'
        case 'icontongji1':
          return 'icon-a-tongji2x'
        case 'iconqukuailian':
          return 'icon-a-qukuailian2x'
        case 'iconshanchu2':
          return 'icon-shanchu5'
      }
    },
    handleSearch (value, id) {
      // 搜索组件返回的数据,并且要通知表单数据变化
      this.loading = true
      if (typeof value === 'object') {
        this.searchText = ''
        this.searchCompQuery = value
      } else {
        this.searchText = value
        this.searchCompQuery = {}
      }
      if (value === '') this.isSearchStatus = false
      if (value) this.isSearchStatus = true
      if (this.isInitTable) {
        const idx = this.initList.findIndex(c=> c === id)
        if (idx === -1) {
          this.initList.push(id)
        }
        const isInit = this.getInitList(id)
        if (isInit) {
          this.handleListInfo(this.dataInfo.pageId, this.searchText, {...this.querys,...this.searchCompQuery},'0',{curpage:1})
          this.isGetListData = true
          this.defaultPrecent = this.splitScreenInfo.defaultPrecent
          this.initCount++
        } else if (this.isGetListData) {
          this.handleListInfo(this.dataInfo.pageId, this.searchText, {...this.querys,...this.searchCompQuery},'0',{curpage:1})
        }
      } else {
        this.handleListInfo(this.dataInfo.pageId, this.searchText, {...this.querys,...this.searchCompQuery},'0',{curpage:1})
      }
    },
    handleButton (value) {
      // 按钮组件返回的数据,并且通知表单变化
      if (value && value.query) {
        const searchQuery = typeof value.query === 'string' ? JSON.parse(value.query) : value.query
        const q = {
          ...searchQuery,
          ...this.organizationalParameters
        }
        this.searchCriteria.query = JSON.stringify(q)
      }
      this.handleListInfo(this.dataInfo.pageId, this.isSearchStatus ? this.searchText : '', value && value.query ? { ...this.dealQueryStr(value.query), ...this.querys } : this.querys, value && value.status ? value.status : '0')
      if (this.dataInfo.info && this.dataInfo.info.apply) {
        this.getAgencyNum(this.dataInfo.info.apply.id)
      }
      this.reloadScreen()
    },
    reloadScreen(){
      const screenRefs = this.$refs.screenRef
      if (screenRefs) {
        for (const ele of screenRefs) {
          if (ele.$refs.screenTreeRef) {
            ele.$refs.screenTreeRef.getTreeData()
          }
        }
      }
    },
    handelRest () {
      // 重置筛选组件
      this.layout = cloneDeep(this.resetAllData.info[this.dataInfo.pageId].layout)
      this.dataList = cloneDeep(this.resetAllData.info[this.dataInfo.pageId].layout)
    },
    sourceAudit (param, filed = {}) {
      //来源transactionManagementList.vue的方法
      const { title: isReadonlyDetails, filedInfo } = filed
      if (param.key === 2) {
        let queryParam = {
          approvalId: this.dataInfo.info.apply.id,
          modifyId: param.data.approvingId,
          person: 1,
        }
        //是否显示头部
        if (this.fromFrame) {
          queryParam.type = 1
        }
        this.pageType = param.pageType || ''
        this.modify = queryParam
        this.isInput = true
        this.isReadonlyDetails = isReadonlyDetails && typeof isReadonlyDetails === 'string' ? isReadonlyDetails : false
        if (filedInfo && filedInfo.detailed && filedInfo.detailed.fieldAppen && filedInfo.detailed.fieldAppen.length > 0) {
          this.isAppenDetailsFeild = filedInfo.detailed.fieldAppen
        }
        // // 修改去上一层组建走
        // this.$emit('upInput', queryParam);
      }
      this.reloadScreen()
    },
    refFlowshow (res) {
      // 子集
      this.flowshow = res
    },
    // 刷新里面的数据
    retRefresh () {
      this.handleListInfo(this.dataInfo.pageId, this.isSearchStatus ? this.searchText : '',this.querys)
      this.reloadScreen()
    },
    // 视频样式刷新数据
    videoFormRefresh (e) {
      if (e) {
        this.listInfo.currentPage = e.curpage
        this.listInfo.tablePageSize = e.pagesize
      }
      this.handleListInfo(this.dataInfo.pageId, this.isSearchStatus ? this.searchText : '',this.querys)
    },
    // 关闭input
    inputClose () {
      this.$refs.AuditOpenInput.closeSetTime()
      this.isReadonlyDetails = false
      this.isAppenDetailsFeild = []
      this.isInput = false
    },
    // 流程查看
    onFlowshow () {
      this.flowshow = this.flowshow ? 0 : 1
      this.$refs.AuditOpenInput.flowshow = this.flowshow
    },
    // 重置刷新
    resetRefresh() {
      this.handleListInfo(this.dataInfo.pageId, this.isSearchStatus ? this.searchText : '', this.querys)
      if (this.dataInfo.info && this.dataInfo.info.apply) {
        this.getAgencyNum(this.dataInfo.info.apply.id)
      }
      this.reloadScreen()
    },
    smsVerifiFun () {
    },
    setJurisdiction () {
      if (this.jurisdictionData) {
        this.jurisdiction = this.jurisdictionData.find((item) => {
          if (this.dataInfo.pageId === '7' || this.dataInfo.pageId === '6') {
            return !item.userId
          } else {
            return item.userId
          }
        })
      }
    },
    goAudit (e) {
      if (e.isread !== 1) {
        //  stayUserIsItReadFunc(e);
        openapiUpdateuserccapproving({ status: 1, userccappId: e.userccappId })
        this.handleListInfo(this.dataInfo.pageId)
        let param = {
          approving: {
            approvingId: e.approvingId,
          },
          userapprovingId: e.userapprovingId,
          approvalId: this.$route.query.approvalId || this.dataInfo.info.apply.id,
        }
        this.$refs.AuditOpenChild.AuditOpenList(param, 1)
      }
    },
    handleCardClick (item) {
      // 处理卡片点击单行
      this.$refs.oneChild.tableDetail(item)
    },
    closeMenu(type) {
      if (!this.$refs.leftMenu || !this.$refs.topMenu) return
      if (type === 'left' && this.isShowMenu) {
        this.$refs.leftMenu.$el.style.width = '180px'
        this.$refs.leftMenu.$el.style.marginRight = '10px'
        this.isShowMenu = false
      } else if (type === 'left' && !this.isShowMenu) {
        this.$refs.leftMenu.$el.style.width = '0px'
        this.$refs.leftMenu.$el.style.marginRight = '0px'
        this.isShowMenu = true
      }
      if (type === 'top' && this.isShowMenu) {
        this.$refs.topMenu.$el.style.height = '41px'
        this.$refs.topMenu.$el.style.marginBottom = '10px'
        this.isShowMenu = false
      } else if (type === 'top' && !this.isShowMenu) {
        this.$refs.topMenu.$el.style.height = '0'
        this.$refs.topMenu.$el.style.marginBottom = '0px'
        this.isShowMenu = true
      }
    }
  },
}
</script>

<style lang="scss" scoped>
// @import "~@/assets/css/clientSide/applicationRouting.scss";
.page {
  --theme-color: #4e86ff;
  $themeColor: var(--theme-color);
  height: 100%;
  width: 100%;
  .vertical-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }
  .split-container {
    display: flex;
    width: 100%;
    height: 100%;
    .table-content {
      width: 100%;
      height: 100%;
    }
    .split-screen {
      width: 100%;
      height: 100%;
      // background-color: #fff;
      position: relative;
    }
    .split-todo {
      position: absolute;
      padding: 16px 4px;
      color: $themeColor;
      background-color: #FFFFFF;
      box-shadow: -1px 0px 4px 0px rgba(0, 0, 0, 0.1);
      z-index: 98;
      width: fit-content;
      cursor: pointer;
      .iconfont {
        font-size: 12px;
        display: inline-block;
        transition: .3s;
      }
    }

    // 左右结构
    .vertical-screen-todo.paneFBtn {
      left: 0;
    }
    .vertical-screen-close-todo.paneFBtn {
      left: 0;
      .iconfont {
        transform: rotate(270deg);
      }
    }
    .vertical-screen-todo.paneSBtn {
      right: 0;
      .iconfont {
        transform: rotate(270deg);
      }
    }
    .vertical-screen-close-todo.paneSBtn {
      right: 0;
      .iconfont {
        transform: rotate(90deg);
      }
    }
    .vertical-list-todo.paneFBtn {
      left: 0;
    }
    .vertical-list-close-todo.paneFBtn {
      left: 0;
    }
    .vertical-list-todo.paneSBtn {
      right: 0;
      top: calc(100% - 49px);
      .iconfont {
        transform: rotate(270deg);
      }
    }
    .vertical-list-close-todo.paneSBtn {
      right: 0;
      top: calc(100% - 49px);
      .iconfont {
        transform: rotate(90deg);
      }
    }
    .vertical-screen-todo {
      top: 0;
      border-radius: 6px 0px 0px 6px;
      .iconfont {
        transform: rotate(90deg);
      }
    }
    .vertical-screen-close-todo {
      top: 0;
      border-radius: 6px 0px 6px 0px;
      .iconfont {
        transform: rotate(270deg);
      }
    }
    .vertical-list-todo {
      top: 0;
      border-radius: 6px 0px 0px 6px;
      .iconfont {
        transform: rotate(90deg);
      }
    }
    .vertical-list-close-todo {
      top: 0;
      z-index: 20;
      border-radius: 6px 0px 6px 0px;
      .iconfont {
        transform: rotate(270deg);
      }
    }

    // 上下结构
    .level-screen-todo.paneFBtn {
      top: 0;
      .iconfont {
        transform: rotate(180deg);
      }
    }
    .level-screen-close-todo.paneFBtn {
      top: 0;
      .iconfont {
        transform: rotate(0);
      }
    }
    .level-screen-todo.paneSBtn {
      bottom: 0;
      .iconfont {
        transform: rotate(0);
      }
    }
    .level-screen-close-todo.paneSBtn {
      bottom: 0;
    }
    .level-list-todo.paneFBtn {
      top: 0;
    }
    .level-list-close-todo.paneFBtn {
      top: 0;
    }
    .level-list-todo.paneSBtn {
      bottom: 0;
      .iconfont {
        transform: rotate(0);
      }
    }
    .level-list-close-todo.paneSBtn {
      bottom: 0;
    }
    .level-screen-todo {
      right: 0;
      border-radius: 0px 0px 6px 6px;
      padding: 4px 16px;
    }
    .level-screen-close-todo {
      right: 0;
      border-radius: 6px 6px 0px 0px;
      padding: 4px 16px;
      .iconfont {
        transform: rotate(180deg);
      }
    }
    .level-list-todo {
      right: 0;
      border-radius: 0px 0px 6px 6px;
      padding: 4px 16px;
    }
    .level-list-close-todo {
      right: 0;
      z-index: 20;
      border-radius: 6px 6px 0px 0px;
      padding: 4px 16px;
      .iconfont {
        transform: rotate(180deg);
      }
    }
  }
  .table-content {
    display: flex;
    flex-direction: column;
    .page-change {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 53px;
      height: 53px;
      border-radius: 100%;
      background-color: #606266;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99;
      i {
        color: #FFF;
      }
    }
    .page-change-left {
      left: 20px;
    }
    .page-change-right {
      right: 20px;
    }
  }
  ::v-deep .tools-left {
    // width: 180px;
    background-color: #fff;
    margin-right: 10px;
    flex-shrink: 0;
    .drag-area {
      width: 100%;
      box-sizing: border-box;
      padding: 10px 0;
      display: flex;
      flex-direction: column;
      .tools-container {
        display: flex;
        flex-direction: column;
        flex: 1;
        .drag-left-content,.drag-right-content {
          display: flex;
          // flex-wrap: wrap;
          flex-direction: column;
          height: initial;
          width: 100%;
          .button-reveal {
            display: flex;
            align-items: center;
            .btn-popover {
              width: 100%;
            }
            .btn-one {
              height: 30px;
            }
            .btn-two {
              justify-content: flex-start;
            }
          }
          .detail {
            margin-right: 0 !important;
            .el-select {
              min-width: initial;
            }
          }
        }
      }
    }
  }
  ::v-deep .page-pagination {
    text-align: right;
    bottom: 0;
    right: 0;
    height: 40px;
    position: fixed;
    right: 10px;
    bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .el-pagination {
      .el-pager {
        .active {
          background-color: $themeColor !important;
        }
        .number {
          &:hover {
            color: $themeColor !important;
          }
        }
      }
    }
  }
  .page-container {
    height: calc(100% - 22px);
    padding: 10px;
    display: flex;
    justify-content: center;
  }
  .navbar-left {
    padding: 0 0 !important;
    overflow: visible;
    position: relative;
    transition: 0.3s;
    .side-btn {
      position: absolute;
      bottom: 0;
      right: -26px;
      text-align: center;
      height: 26px;
      line-height: 26px;
      width: 26px;
      background: #fff;
      cursor: pointer;
      .icon-shuangjiantouzuo {
        color: #666666;
        transition: 0.3s;
        display: inline-block;
      }
      .menu-active {
        transform: rotate(180deg);
      }
    }
    .navbar {
      padding-top: 10px;
      .navbar-item-left {
        display: flex;
        position: relative;
        align-items: center;
        font-size: 14px;
        color: #333333;
        height: 36px;
        cursor: pointer;
        margin: 0 10px;
        margin-bottom: 10px;
        transition: 0.3s;
        &:hover {
          .iconbianji {
            visibility: initial;
          }
        }
        &-container {
          padding: 10px 0 10px 15px;
          display: flex;
          align-items: center;
          position: relative;
          .iconfont {
            margin-right: 5px;
          }
          span {
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 90px;
          }
        }
        .red-title {
          min-width: 16px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          background: #e47470;
          border-radius: 12px;
          font-size: 12px;
          color: #fff;
          position: absolute;
          top: -6px;
          right: 0;
          padding: 0 4px;
          &::after {
            content: " ";
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-bottom: 6px solid transparent;
            border-top: 6px solid #e47470;
            position: absolute;
            bottom: -8px;
            left: -2px;
            -webkit-transform: rotate(28deg);
            transform: rotate(28deg);
          }
        }
        .iconbianji {
          margin-left: 10px;
          visibility: hidden;
        }
      }
      .active {
        color: $themeColor;
        background: #4ea7ff10;
      }
    }
  }
  .no-power {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &-img {
      width: 50%;
      padding-bottom: 20px;
    }
    &-tips {
      color: #4e86ff;
    }
  }
  .navbar-top {
    height: 41px;
    overflow: visible;
    position: relative;
    transition: 0.3s;
    .side-btn {
      position: absolute;
      bottom: -26px;
      right: 0;
      text-align: center;
      height: 26px;
      line-height: 26px;
      width: 26px;
      background: #fff;
      cursor: pointer;
      .icon-shuangjiantouzuo {
        color: #666666;
        transition: 0.3s;
        display: inline-block;
        transform: rotate(-90deg);
      }
      .menu-active {
        transform: rotate(-270deg);
      }
    }
    .navbar {
      display: flex;
      overflow: hidden;
      height: 100%;
      width: 100%;
      .navbar-item-top {
        display: flex;
        align-items: center;
        position: relative;
        font-size: 14px;
        color: #333333;
        height: 100%;
        cursor: pointer;
        margin-right: 10px;
        .red-title {
          min-width: 16px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          background: #e47470;
          border-radius: 12px;
          font-size: 12px;
          color: #fff;
          position: absolute;
          top: 0;
          right: -15px;
          padding: 0 4px;
          &::after {
            content: " ";
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-bottom: 6px solid transparent;
            border-top: 6px solid #e47470;
            position: absolute;
            bottom: -8px;
            left: -2px;
            -webkit-transform: rotate(28deg);
            transform: rotate(28deg);
          }
        }
        .top-c {
          transition: 0.3s;
          display: flex;
          align-items: center;
          padding: 2px 10px;
          position: relative;
          border-radius: 4px;
          height: 24px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .active {
        color: $themeColor;
        div {
          background-color: rgba(78, 166, 255, 0.1);
        }
      }
    }
  }

  .el-container {
    height: 100%;
    .el-main {
      background: #fff;
      padding: 10px 0 10px 10px;
      border-radius: 4px;
      position: relative;
      // height: 100%;
    }
    .el-header {
      background: #fff;
      margin-bottom: 10px;
      border-radius: 4px;
      .header-tools {
        min-height: 40px;
        &-item {
          width:100%;
          padding: 5px;
          box-sizing: border-box;
          background-color: #fff;
        }
      }
    }
    .el-aside {
      height: 100%;
      margin-right: 10px;
      padding: 20px 10px 20px 20px;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      background: #fff;
      border-right: 1px #eee solid;
      box-sizing: border-box;
    }
  }
  .drag-area {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    display: flex;
    .tools-container {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      width: 100%;
      box-sizing: border-box;
      .drag-left-content {
        display: flex;
        height: 30px;
      }
      .drag-right-content {
        display: flex;
        height: 30px;
        justify-content: flex-end;
      }
      .tool {
        position: absolute;
        right: 0;
        top: 0;
        .toolArea {
          display: flex;
          cursor: pointer;
          justify-content: center;
        }
      }
    }
  }
}
::v-deep .popUps {
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
    .el-dialog__header {
      padding: 18px;
      background-color: #F5F5F5;
      border-radius: 14px 14px 0 0;
    .el-dialog__title{
      font-size: 14px;
      color: #333;
      font-weight: 400;
    }
    .el-dialog__headerbtn{
      top: 8px;
      font-size: 20px;
    }
    .el-dialog__body {
      padding: 5px;
    }
  }
}

.card {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

::v-deep .el-scrollbar {
  .el-scrollbar__wrap {
    overflow-x: hidden !important;
  }
}

// pc弹窗高度-自适应
:deep(.dialog-height-auto) {
  min-height: inherit;
  .oaExamineInput {
    position: inherit;
    .oaExamineAllArea {
      .wisdomSubmit {
        .wisdomSubmitBox {
          position: inherit;
        }
      }
    }
  }
}

.navbar-orgin {
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
  background: #fff;
  border-right: 1px #eee solid;
  margin-right: 10px;
  padding: 20px 0;
  box-sizing: border-box;
  flex-shrink: 0;
  &-tools {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 8px;
    box-sizing: border-box;
    margin-bottom: 5px;
    .tools-close {
      color: #333333;
      font-weight: 400;
      font-size: 14px;
      cursor: pointer;
      .iconfont {
        transition: .3s;
        display: inline-block;
      }
    }
  }
  &-search {
    position: relative;
    margin-bottom: 16px;
    padding: 0 8px;
    width: 90%;
    .input-box {
      height: 32px;
      width: 100%;

      ::v-deep .el-input {
        border-radius: 23px;
      }
      ::v-deep .el-input .el-input__inner {
        background: #f7f9fa;
        border: none;
        height: 32px;
        padding-right: 30px;
        border-radius: 23px;
      }
    }
    .iocn {
      position: absolute;
      top: 0;
      right: 8px;
      background-color: #38a2fb;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      i {
        color: #ffffff;
      }
    }
  }
  &-tree {
    height: 780px;
    overflow-x: hidden;
    width: 100%;
    .custom-tree-node{
      display: flex;
      align-items: center;
      position: relative;
      .orgin-text{
        display: inline-block;
        width: 188px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .user-sex-icon {
        width: 12px;
        height: 12px;
        border-radius: 2px;
        background-color: transparent;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          color: #fff;
          font-size: 10px;
        }
      }
      .none-type {
        background-color: rgba(225,230,235,0.5);
        color: #adb0b2;
        display: inline-block;
        padding: 4px 10px;
        text-align: center;
        border-radius: 4px;
        margin-left: 8px;
      }
  }  
  ::v-deep .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: rgba(54, 162, 251, 0.1);
    position: relative;
    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 2px;
      height: 100%;
      background-color: #36A2FB;
    }
  }
  ::v-deep .el-tree-node__content{
    height: 28px;
    .line{
        position: absolute;
        display: block;
        left: -32px;
        bottom: 12px;
        width: 13px;
        height: 500px;
        border-left: 1px solid #DDEDFB;
        border-bottom: 1px solid #DDEDFB;
      }
    }
    &-item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      box-sizing: border-box;
      .tree-icon{
        margin-right: 8px;
        cursor: pointer;
      }
    }
  }
  .orgin-search{
    height: 780px;
    overflow-x: hidden;
    width: 100%;
    &-item {
      height: 40px;
      line-height: 40px;
      padding-left: 16px;
      cursor: pointer;
      &:hover {
        background: #f7f9fa;
        font-weight: 500;
        color: #38a2fb;
      }
    }
  }
}
</style>
